(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7312],{

/***/ 37973:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[productSlug]",
      function () {
        return __webpack_require__(11162);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 98503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _blockHeader_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84632);
/* harmony import */ var _blockHeader_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_blockHeader_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



var BlockHeader = function(param) {
    var title = param.title;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_blockHeader_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["block-header"]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
            className: (_blockHeader_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["block-header__title__custom"]),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_blockHeader_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["title-line-fms"])
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_blockHeader_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["title-name-fms"]),
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_blockHeader_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["title-line-fms"])
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BlockHeader);


/***/ }),

/***/ 64465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69587);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _shared_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12820);
/* harmony import */ var _shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_shared_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _schemaorg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91257);








var PageHeader = function(props) {
    var _breadcrumb = props.breadcrumb, breadcrumb = _breadcrumb === void 0 ? [] : _breadcrumb, dbName = props.dbName;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var schema = (0,_schemaorg__WEBPACK_IMPORTED_MODULE_6__/* .schemaPageHeader */ .ed)(dbName, router.asPath, breadcrumb);
    if (breadcrumb.length > 0) {
        var lastIndex = breadcrumb.length - 1;
        breadcrumb = breadcrumb.map(function(item, index) {
            var link;
            if (lastIndex === index) {
                link = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_5___default()), {
                            id: schema.name,
                            type: "application/ld+json",
                            dangerouslySetInnerHTML: {
                                __html: JSON.stringify(schema)
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            className: "".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-item"]), " ").concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-item-active"])),
                            "aria-current": "page",
                            children: item.title
                        })
                    ]
                }, index);
            } else {
                link = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                    className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-item"]),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: item.url,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: item.title
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_3__/* .ArrowRoundedRight6x9Svg */ .EO, {
                            className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-arrow"])
                        })
                    ]
                }, index);
            }
            return link;
        });
        breadcrumb = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["page-header__breadcrumb"]),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                "aria-label": "breadcrumb",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                    className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default().breadcrumb),
                    children: breadcrumb
                })
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["page-header"]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["page-header__container"]), " container"),
            children: breadcrumb
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageHeader);


/***/ }),

/***/ 2598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_recaptcha_v3__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69498);



var ReCaptchaWrapper = function(param) {
    var children = param.children, recaptchaActive = param.recaptchaActive, recaptchaKey = param.recaptchaKey;
    if (!+recaptchaActive) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: children
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_recaptcha_v3__WEBPACK_IMPORTED_MODULE_2__/* .ReCaptchaProvider */ .dR, {
        useEnterprise: true,
        reCaptchaKey: recaptchaKey,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ReCaptchaWrapper);


/***/ }),

/***/ 11162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _productSlug_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./helper.js
var helper = __webpack_require__(63385);
// EXTERNAL MODULE: ./components/ForCWV/Wrappers/MainLayout.tsx + 32 modules
var MainLayout = __webpack_require__(75947);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
;// CONCATENATED MODULE: ./services/productGroupService.ts


function filterCustomerGroupPrices(customerGroupPrices, customerGroupId, product, innerPage) {
    return customerGroupPrices === null || customerGroupPrices === void 0 ? void 0 : customerGroupPrices.filter(function(element) {
        if ((element.customer_group_id === null || customerGroupId === element.customer_group_id) && element.product_id === product.id) {
            if (innerPage || element.qty === "1") {
                return true;
            }
        }
        return false;
    });
}
function applyDiscountToCustomerGroupPrices(customerGroupPrices, product) {
    return customerGroupPrices === null || customerGroupPrices === void 0 ? void 0 : customerGroupPrices.map(function(elem) {
        if (elem.value_type === "discount") {
            var ref;
            var discountValue = 100 - +elem.value;
            var priceGroupVal = ((ref = product.flats) === null || ref === void 0 ? void 0 : ref[0].price) * discountValue / 100;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, elem), {
                value: priceGroupVal.toString()
            });
        }
        return elem;
    });
}
function getMinimumValues(customerGroupPrices) {
    var qtyToMinValue = new Map();
    customerGroupPrices === null || customerGroupPrices === void 0 ? void 0 : customerGroupPrices.forEach(function(item) {
        var qty = item.qty;
        var value = item.value;
        if (!qtyToMinValue.has(qty) || +value < +qtyToMinValue.get(qty)) {
            qtyToMinValue.set(qty, value);
        }
    });
    return qtyToMinValue;
}
function filterByMinimumValues(customerGroupPrices, qtyToMinValue, currRate) {
    var ref;
    var filteredPrices = customerGroupPrices === null || customerGroupPrices === void 0 ? void 0 : customerGroupPrices.filter(function(item) {
        return item.value === qtyToMinValue.get(item.qty);
    });
    if (!filteredPrices) {
        return undefined;
    }
    var sortedPrices = filteredPrices.sort(function(a, b) {
        return +a.qty - +b.qty;
    });
    var addCurrencyInPrices = sortedPrices.map(function(customerGroup) {
        if (currRate) {
            var currencyToggle = parseFloat(customerGroup.value) * +currRate;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, customerGroup), {
                value: String(currencyToggle)
            });
        }
        return customerGroup;
    });
    var minValue = (ref = addCurrencyInPrices[0]) === null || ref === void 0 ? void 0 : ref.value;
    return addCurrencyInPrices === null || addCurrencyInPrices === void 0 ? void 0 : addCurrencyInPrices.map(function(item) {
        if (minValue) {
            item.value = String(Math.min(+item.value, +minValue));
            minValue = item.value;
        }
        return item;
    });
}
var updatedProductGroupToggle = function(customerGroupPrices, customerGroupId, product, innerPage, currRate) {
    var filteredCustomerGroupPrices = filterCustomerGroupPrices(customerGroupPrices, customerGroupId, product, innerPage);
    var updatedCustomerGroupPrices = applyDiscountToCustomerGroupPrices(filteredCustomerGroupPrices, product);
    if (innerPage) {
        var qtyToMinValue = getMinimumValues(updatedCustomerGroupPrices);
        return filterByMinimumValues(updatedCustomerGroupPrices, qtyToMinValue, currRate);
    } else {
        var findGroup = updatedCustomerGroupPrices === null || updatedCustomerGroupPrices === void 0 ? void 0 : updatedCustomerGroupPrices.reduce(function(min, item) {
            return Number(item.value) < Number(min.value) ? item : min;
        }, updatedCustomerGroupPrices[0]);
        if (customerGroupPrices && findGroup) {
            var ref;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
                flats: [
                    (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (ref = product.flats) === null || ref === void 0 ? void 0 : ref[0]), {
                        special_price: findGroup.value
                    })
                ]
            });
        }
        return product;
    }
};

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(81043);
// EXTERNAL MODULE: ./atoms/Toast/useToast.ts
var useToast = __webpack_require__(54213);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/ForCWV/InnerPageProduct/customInnerPage.module.scss
var customInnerPage_module = __webpack_require__(17192);
var customInnerPage_module_default = /*#__PURE__*/__webpack_require__.n(customInnerPage_module);
// EXTERNAL MODULE: ./svg/index.js
var svg = __webpack_require__(69587);
// EXTERNAL MODULE: ./store/wishlist/wishlistActions.js
var wishlistActions = __webpack_require__(84444);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./components/shared/products/product.module.scss
var product_module = __webpack_require__(30420);
var product_module_default = /*#__PURE__*/__webpack_require__.n(product_module);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./store/general/index.ts + 3 modules
var general = __webpack_require__(26298);
;// CONCATENATED MODULE: ./components/ForCWV/InnerPageProduct/CustomDetailItem.tsx









var CustomDetailItem = function(param) {
    var detail = param.detail, domain = param.domain, dbName = param.dbName, showDetailsInFront = param.showDetailsInFront, translationsData = param.translationsData;
    var attrName = detail.attribute_name, attrValue = detail.attribute_value, textValue = detail.text_value, booleanVal = detail.boolean_value, tmp = detail.attribute, ref = (0,_sliced_to_array/* default */.Z)(tmp === void 0 ? [] : tmp, 1), tmp1 = ref[0], ref1 = tmp1 === void 0 ? {} : tmp1, tmp2 = ref1.type, attrType = tmp2 === void 0 ? "" : tmp2;
    var ref2 = (0,react.useState)(false), isReadMoreVisible = ref2[0], setIsReadMoreVisible = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,react.useState)("") || [
        ""
    ], 2), tmp3 = ref3[0], valClass = tmp3 === void 0 ? "" : tmp3, setValClass = ref3[1];
    var ref4 = (0,react.useState)(false), isOpen = ref4[0], setIsOpen = ref4[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var valueRef = (0,react.useRef)(null);
    var handleOpenFile = function(url) {
        dispatch((0,general/* setPopup */.ZA)(true));
        dispatch((0,general/* setPopupName */.Sq)("details_image"));
        dispatch((0,general/* setDetailUrl */.h7)(url));
    };
    (0,react.useEffect)(function() {
        var lineHeight = parseFloat(window.getComputedStyle(valueRef.current).lineHeight);
        var maxLines = 2;
        var maxHeight = lineHeight * maxLines;
        if (valueRef.current.clientHeight > maxHeight) {
            setIsReadMoreVisible(true);
            setValClass("detail_content");
        }
    }, [
        valueRef.current
    ]);
    var attrTypeHandle = function(textValue, attrName, attrType, attrValue) {
        var imageElement = /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (product_module_default()).icon_for_open,
            onClick: function() {
                return handleOpenFile((0,helper/* domainUrl */.HJ)("".concat(dbName, "/storage/").concat(domain, "/").concat(textValue)));
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* ImageIcon */.XB, {})
        });
        var fileElement = /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (product_module_default()).icon_for_open,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/storage/").concat(domain, "/").concat(textValue)),
                download: attrName,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* File */.$B, {})
            })
        });
        var _obj;
        return _obj = {}, (0,_define_property/* default */.Z)(_obj, attrType, {
            "true": attrValue,
            "false": attrValue
        }), (0,_define_property/* default */.Z)(_obj, "boolean", {
            "true": /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* Yes */.sk, {}),
            "false": /*#__PURE__*/ (0,jsx_runtime.jsx)(svg.No, {})
        }), (0,_define_property/* default */.Z)(_obj, "image", {
            "true": imageElement,
            "false": imageElement
        }), (0,_define_property/* default */.Z)(_obj, "file", {
            "true": fileElement,
            "false": fileElement
        }), _obj;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            display: showDetailsInFront && !!attrName && (attrType !== "boolean" && !!attrValue || attrType === "boolean") ? "flex" : "none"
        },
        className: (product_module_default()).detail_row,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (product_module_default()).detail_key,
                children: attrName
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (product_module_default()).detail_value,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (product_module_default())[valClass],
                        style: {
                            wordWrap: "break-word"
                        },
                        ref: valueRef,
                        children: attrTypeHandle(textValue, attrName, attrType, attrValue)[attrType]["".concat(!!booleanVal)]
                    }),
                    isReadMoreVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (product_module_default()).read_more,
                        onClick: function() {
                            if (!isOpen) {
                                setValClass("");
                            } else {
                                setValClass("detail_content");
                            }
                            setIsOpen(function(prevState) {
                                return !prevState;
                            });
                        },
                        children: isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                            children: [
                                translationsData === null || translationsData === void 0 ? void 0 : translationsData.ReadLess,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* ArrowRoundedUp13x8Svg */.aO, {})
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                            children: [
                                translationsData === null || translationsData === void 0 ? void 0 : translationsData.ReadMore,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* ArrowRoundedDown12x7Svg */.bD, {})
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var InnerPageProduct_CustomDetailItem = (CustomDetailItem);

;// CONCATENATED MODULE: ./components/ForCWV/InnerPageProduct/CustomDetails.tsx




var CustomDetails = function(param) {
    var details = param.details, isSelectDetail = param.isSelectDetail, domain = param.domain, dbName = param.dbName, showDetailsInFront = param.showDetailsInFront, translationsData = param.translationsData;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (product_module_default()).details_block,
        children: details.map(function(detail, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerPageProduct_CustomDetailItem, {
                detail: detail,
                domain: domain,
                dbName: dbName,
                showDetailsInFront: showDetailsInFront,
                translationsData: translationsData
            }, index);
        })
    });
};
/* harmony default export */ var InnerPageProduct_CustomDetails = (CustomDetails);

// EXTERNAL MODULE: ./components/shared/InputNumber.tsx
var InputNumber = __webpack_require__(48168);
// EXTERNAL MODULE: ./store/formbuilder/index.ts + 3 modules
var formbuilder = __webpack_require__(11428);
;// CONCATENATED MODULE: ./components/ForCWV/InnerPageProduct/CustomSideBar.tsx








var CustomSideBar = function(param) {
    var ProductAddToCart_INTL = param.ProductAddToCart_INTL, actionClassName = param.actionClassName, handleCardClick = param.handleCardClick, isButtonDisabled = param.isButtonDisabled, wishListButtonClick = param.wishListButtonClick, wishIconClicked = param.wishIconClicked, minimalQty = param.minimalQty, maximalQty = param.maximalQty, inpValQuantity = param.inpValQuantity, setQuantity = param.setQuantity, requestFormDetails = param.requestFormDetails, requestFormInfo = param.requestFormInfo;
    var dispatch = (0,es/* useDispatch */.I0)();
    var Button = function(param) {
        var _className = param.className, className = _className === void 0 ? "" : _className, _title = param.title, title = _title === void 0 ? ProductAddToCart_INTL : _title, _onClick = param.onClick, onClick = _onClick === void 0 ? function() {
            return handleCardClick(inpValQuantity);
        } : _onClick, _isButtonDisabledInside = param.isButtonDisabledInside, isButtonDisabledInside = _isButtonDisabledInside === void 0 ? false : _isButtonDisabledInside;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((customInnerPage_module_default())["product__actions-item"], " ").concat((customInnerPage_module_default())["product__actions-item--addToCart"]),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((customInnerPage_module_default())["product__actions-item"], " ").concat((customInnerPage_module_default())["product__actions-item--addToCart"], " ").concat(actionClassName),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        e.preventDefault();
                                        return [
                                            4,
                                            onClick()
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(e) {
                            return _ref.apply(this, arguments);
                        };
                    }(),
                    disabled: isButtonDisabledInside,
                    className: "btn btn-orange ".concat((customInnerPage_module_default())["inner-addToCart"], " ").concat((customInnerPage_module_default())["rounded-pills"], " btn-lg ").concat(className),
                    children: title
                })
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (customInnerPage_module_default()).product__sidebar,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
            className: (customInnerPage_module_default()).product__options,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "form-group ".concat((customInnerPage_module_default()).product__option),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (customInnerPage_module_default()).product__actions,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((customInnerPage_module_default())["product__actions-item"], " ").concat((customInnerPage_module_default())["product-inner-quantity"]),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputNumber/* default */.Z, {
                                id: "product-quantity",
                                "aria-label": "Quantity",
                                className: (customInnerPage_module_default()).product__quantity,
                                size: "lg",
                                min: minimalQty,
                                max: maximalQty,
                                value: inpValQuantity,
                                onChange: function(quantity) {
                                    if (quantity > maximalQty) {
                                        setQuantity(maximalQty);
                                    } else {
                                        setQuantity(quantity);
                                    }
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (customInnerPage_module_default())["inner-buttons-wrapper"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                                    isButtonDisabledInside: isButtonDisabled
                                }),
                                Number(requestFormDetails === null || requestFormDetails === void 0 ? void 0 : requestFormDetails.requestFormActive) && (requestFormDetails === null || requestFormDetails === void 0 ? void 0 : requestFormDetails.requestFormBtn) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                                    isButtonDisabledInside: false,
                                    className: "inner-request-form-button",
                                    title: requestFormDetails === null || requestFormDetails === void 0 ? void 0 : requestFormDetails.requestFormBtn,
                                    onClick: function() {
                                        var ref;
                                        return dispatch((0,formbuilder/* setFormPopupOpen */.YK)({
                                            id: requestFormInfo === null || requestFormInfo === void 0 ? void 0 : (ref = requestFormInfo.data) === null || ref === void 0 ? void 0 : ref.id,
                                            open: true
                                        }));
                                    }
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "\n                                ".concat((customInnerPage_module_default())["product__actions-item"], "\n                                ").concat((customInnerPage_module_default())["product__actions-item--wishlist"], "\n                                ").concat((customInnerPage_module_default())["liked-button-wrapper"], "\n                                ").concat((requestFormDetails === null || requestFormDetails === void 0 ? void 0 : requestFormDetails.requestFormBtn) ? (customInnerPage_module_default())["like-btn-self-flex"] : "", "\n                            "),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    "aria-label": "Wish list",
                                    title: "Wishlist",
                                    onClick: wishListButtonClick,
                                    className: "btn-light btn-svg-icon btn-svg-icon--fake-svg",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (customInnerPage_module_default())["wishlist-icon-wrapper"],
                                        children: wishIconClicked
                                    })
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var InnerPageProduct_CustomSideBar = (CustomSideBar);

;// CONCATENATED MODULE: ./components/ForCWV/InnerPageProduct/CustomQuantityTable.tsx



var CustomQuantityTable = function(param) {
    var QuantityDiscount_INTL = param.QuantityDiscount_INTL, quantityColumnHandler = param.quantityColumnHandler, displayFilterGroup = param.displayFilterGroup;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        style: {
            maxWidth: "100%",
            display: displayFilterGroup
        },
        className: (customInnerPage_module_default()).product__meta,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
            style: {
                maxWidth: "100%"
            },
            className: (customInnerPage_module_default())["product__meta-availability"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (customInnerPage_module_default()).quantity_table_title,
                    children: QuantityDiscount_INTL
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (customInnerPage_module_default()).quantity_table_main,
                    children: [
                        quantityColumnHandler("Quantity", true),
                        quantityColumnHandler("Price", false)
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var InnerPageProduct_CustomQuantityTable = (CustomQuantityTable);

// EXTERNAL MODULE: ./node_modules/next-share/dist/next-share.es.js
var next_share_es = __webpack_require__(21818);
;// CONCATENATED MODULE: ./components/ForCWV/InnerPageProduct/CustomSocialLinks.tsx





var CustomSocialLinks = function(param) {
    var dbName = param.dbName, productSlug = param.productSlug, domain = param.domain;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (customInnerPage_module_default()).socialLinksBox,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_share_es/* FacebookShareButton */.Dk, {
                url: "https://".concat(dbName, "/products/").concat(productSlug),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_share_es/* FacebookIcon */.Vq, {
                    size: 32,
                    round: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_share_es/* TwitterShareButton */.B, {
                url: "https://".concat(dbName, "/products/").concat(productSlug),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_share_es/* TwitterIcon */.Zm, {
                    size: 32,
                    round: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_share_es/* PinterestShareButton */.MC, {
                url: "https://".concat(dbName, "/products/").concat(productSlug),
                media: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/storage/").concat(domain, "/configuration/logo/logo.webp")),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_share_es/* PinterestIcon */.cH, {
                    size: 32,
                    round: true
                })
            })
        ]
    });
};
/* harmony default export */ var InnerPageProduct_CustomSocialLinks = (CustomSocialLinks);

;// CONCATENATED MODULE: ./components/ForCWV/InnerPageProduct/CustomDetailTabButtons.tsx


 // Import useState
var CustomDetailTabButtons = function(param) {
    var boxAboutDetailsClass = param.boxAboutDetailsClass, isSelectedDetailSectionClass = param.isSelectedDetailSectionClass, productDescOptionName = param.productDescOptionName, Details_INTL = param.Details_INTL, selectTab = param.selectTab, showDescription = param.showDescription, showDetailsInFront = param.showDetailsInFront;
    var hideDescription = {
        "true": /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat(isSelectedDetailSectionClass.first, " "),
            onClick: selectTab,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((customInnerPage_module_default())["product-inner-description-title"]),
                children: productDescOptionName
            })
        }),
        "false": null
    };
    var hideDetails = {
        "true": /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                display: boxAboutDetailsClass === null || boxAboutDetailsClass === void 0 ? void 0 : boxAboutDetailsClass.display
            },
            className: "".concat(isSelectedDetailSectionClass.second),
            id: "detail",
            onClick: selectTab,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (customInnerPage_module_default())["product-inner-description-title"],
                id: "detail",
                children: Details_INTL
            })
        }),
        "false": null
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((customInnerPage_module_default()).tab_buttons, " ").concat((customInnerPage_module_default())[boxAboutDetailsClass === null || boxAboutDetailsClass === void 0 ? void 0 : boxAboutDetailsClass.className], " "),
        children: [
            hideDescription["".concat(showDescription)],
            hideDetails["".concat(showDetailsInFront)]
        ]
    });
};
/* harmony default export */ var InnerPageProduct_CustomDetailTabButtons = (CustomDetailTabButtons);

// EXTERNAL MODULE: ./store/product/index.ts + 3 modules
var store_product = __webpack_require__(19901);
;// CONCATENATED MODULE: ./components/ForCWV/InnerPageProduct/CustomProductOptions.tsx







var CustomProductOptions = function(param) {
    var product = param.product, productOptions = param.productOptions, translationsData = param.translationsData, refsMap = param.refsMap;
    var dispatch = (0,es/* useDispatch */.I0)();
    var customOptionOpen = (0,es/* useSelector */.v9)(function(state) {
        return state.product.customOptionOpen;
    });
    var optionValues = (0,es/* useSelector */.v9)(function(state) {
        return state.product.optionValues;
    });
    var notFilledOptions = (0,es/* useSelector */.v9)(function(state) {
        return state.product.notFilledOptions;
    });
    var ref = (0,react.useState)(null), selectedId = ref[0], setSelectedId = ref[1];
    (0,react.useEffect)(function() {
        if (customOptionOpen.length > 0) {
            var handleClickOutside = function(event) {
                var clickedInside = false;
                refsMap === null || refsMap === void 0 ? void 0 : refsMap.current.forEach(function(ref) {
                    if (ref.contains(event.target)) clickedInside = true;
                });
                if (!clickedInside) {
                    dispatch((0,store_product/* setCustomOptionOpenAction */.Bq)({
                        isOutsideClick: true,
                        optionId: 0
                    }));
                }
            };
            document.addEventListener("mousedown", handleClickOutside);
            return function() {
                return document.removeEventListener("mousedown", handleClickOutside);
            };
        }
    }, [
        customOptionOpen.length
    ]);
    var optionIdShowToggle = function(elemId) {
        var foundOption = optionValues === null || optionValues === void 0 ? void 0 : optionValues.find(function(item) {
            return (item === null || item === void 0 ? void 0 : item.id) === elemId;
        });
        if (foundOption) return foundOption === null || foundOption === void 0 ? void 0 : foundOption.label;
    };
    var Select = function(param) {
        var option = param.option;
        var ref;
        var required = notFilledOptions === null || notFilledOptions === void 0 ? void 0 : notFilledOptions.some(function(item) {
            return item === (option === null || option === void 0 ? void 0 : option.id);
        });
        var findItem = customOptionOpen.some(function(item) {
            return item === option.id;
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (customInnerPage_module_default()).select__option,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (customInnerPage_module_default()).option_title,
                    children: option === null || option === void 0 ? void 0 : option.title
                }),
                Number(option === null || option === void 0 ? void 0 : option.required) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    style: {
                        color: "red"
                    },
                    children: " *"
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    ref: function(el) {
                        if (el) refsMap === null || refsMap === void 0 ? void 0 : refsMap.current.set(option.id, el);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (customInnerPage_module_default()).option_label,
                            style: required ? {
                                border: "1px solid red"
                            } : {},
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (customInnerPage_module_default()).dropdown_btn,
                                onClick: function() {
                                    return dispatch((0,store_product/* setCustomOptionOpenAction */.Bq)({
                                        optionId: option.id
                                    }));
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (customInnerPage_module_default()).selected__option,
                                        children: optionIdShowToggle(option.id) || translationsData.Select
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* CustomSelectArrow */.xl, {
                                        className: "".concat((customInnerPage_module_default()).drop_down_arrow, " ").concat((customInnerPage_module_default())[findItem ? "drop_down_opened" : ""])
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                display: findItem ? "block" : "none"
                            },
                            className: (customInnerPage_module_default()).options_dropdown,
                            children: option === null || option === void 0 ? void 0 : (ref = option.children) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((customInnerPage_module_default()).option_dropdown_value, " ").concat(selectedId === item.id ? (customInnerPage_module_default()).selected : ""),
                                    onClick: function() {
                                        setSelectedId(item.id);
                                        dispatch((0,store_product/* setOptionValuesAction */.vD)({
                                            id: option.id,
                                            label: item.label,
                                            price: String(item.price),
                                            optionId: item.id,
                                            type: option === null || option === void 0 ? void 0 : option.type
                                        }));
                                        dispatch((0,store_product/* setCustomOptionOpenAction */.Bq)({
                                            optionId: option.id
                                        }));
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        htmlFor: item.admin_name,
                                        children: item.label
                                    })
                                }, item.id);
                            })
                        })
                    ]
                }),
                required ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (customInnerPage_module_default())["err-block"],
                    children: translationsData === null || translationsData === void 0 ? void 0 : translationsData.RequiredField
                }) : null
            ]
        }, option.id);
    };
    var text = function(param) {
        var option = param.option;
        var ref;
        var required = notFilledOptions === null || notFilledOptions === void 0 ? void 0 : notFilledOptions.some(function(item) {
            return item === (option === null || option === void 0 ? void 0 : option.id);
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (customInnerPage_module_default()).text__option,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: (customInnerPage_module_default()).option_title,
                    children: [
                        option === null || option === void 0 ? void 0 : option.title,
                        Number(option === null || option === void 0 ? void 0 : option.required) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            style: {
                                color: "red"
                            },
                            children: " *"
                        }) : null,
                        (product === null || product === void 0 ? void 0 : (ref = product.attribute_family) === null || ref === void 0 ? void 0 : ref.code) === "Donation" ? "" : " + " + (option === null || option === void 0 ? void 0 : option.price)
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                    name: "forTextOption",
                    className: (customInnerPage_module_default())["auto-expand"],
                    onInput: function(e) {
                        e.target.style.height = "50px";
                        e.target.style.height = "".concat(e.target.scrollHeight, "px");
                    },
                    maxLength: Number(option === null || option === void 0 ? void 0 : option.max_characters),
                    onChange: function(e) {
                        var ref;
                        var targetValue = (product === null || product === void 0 ? void 0 : (ref = product.attribute_family) === null || ref === void 0 ? void 0 : ref.code) === "Donation" ? e.target.value.replace(/\D/g, "") : e.target.value;
                        e.target.value = targetValue;
                        var actionAttrs = {
                            id: option.id,
                            label: targetValue,
                            price: String(option === null || option === void 0 ? void 0 : option.price),
                            optionId: targetValue,
                            type: option === null || option === void 0 ? void 0 : option.type
                        };
                        if (targetValue) {
                            dispatch((0,store_product/* setOptionValuesAction */.vD)(actionAttrs));
                        } else {
                            dispatch((0,store_product/* setOptionValuesAction */.vD)((0,_object_spread/* default */.Z)({
                                isFiltered: true
                            }, actionAttrs)));
                        }
                    },
                    style: required ? {
                        border: "1px solid red"
                    } : {}
                }),
                required ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (customInnerPage_module_default())["err-block"],
                    children: translationsData === null || translationsData === void 0 ? void 0 : translationsData.RequiredField
                }) : null
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (customInnerPage_module_default())["configurable-attributes"],
        children: productOptions === null || productOptions === void 0 ? void 0 : productOptions.map(function(option, index) {
            if ((option === null || option === void 0 ? void 0 : option.type) === "select") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (customInnerPage_module_default()).each__option,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Select, {
                        option: option
                    })
                }, index);
            } else if ((option === null || option === void 0 ? void 0 : option.type) === "text") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (customInnerPage_module_default()).each__option,
                    children: text({
                        option: option
                    })
                }, index);
            }
            return null;
        })
    });
};
/* harmony default export */ var InnerPageProduct_CustomProductOptions = (CustomProductOptions);

// EXTERNAL MODULE: ./components/builder/Button/FormModal/formModal.module.scss
var formModal_module = __webpack_require__(74743);
var formModal_module_default = /*#__PURE__*/__webpack_require__.n(formModal_module);
;// CONCATENATED MODULE: ./components/shared/ModalLayout/index.tsx






var ModalLayout = function(param) {
    var title = param.title, close = param.close, children = param.children;
    var modalRef = (0,react.useRef)(null);
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        var handleClickOutside = function(event) {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                dispatch((0,general/* openModalLayoutAction */.oJ)(false));
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (formModal_module_default()).popup_pos,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((formModal_module_default()).main_popup, " ").concat(title ? (formModal_module_default()).main_popup_title : ""),
            ref: modalRef,
            children: [
                title ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (formModal_module_default()).main_popup_header,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* CloseSvg */.sZ, {
                            style: {
                                width: "20px",
                                height: "20px",
                                cursor: "pointer"
                            },
                            onClick: function() {
                                return close();
                            }
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* CloseSvg */.sZ, {
                    style: {
                        float: "right",
                        width: "20px",
                        height: "20px",
                        cursor: "pointer"
                    },
                    onClick: function() {
                        return close();
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (formModal_module_default()).main_popup_product_wrapper,
                    children: children
                })
            ]
        })
    });
};
/* harmony default export */ var shared_ModalLayout = (ModalLayout);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_array.mjs
var _to_array = __webpack_require__(59637);
;// CONCATENATED MODULE: ./components/ForCWV/InnerPageProduct/SizeChartContent.tsx





var SizeChartContent = function(param) {
    var sizeChart = param.sizeChart, dbName = param.dbName, domain = param.domain;
    var infoChart = [];
    try {
        var parsed = JSON.parse((sizeChart === null || sizeChart === void 0 ? void 0 : sizeChart.size_chart) || "[]");
        if (Array.isArray(parsed)) infoChart = parsed;
    } catch (e) {
        console.error("Invalid size_chart JSON:", e);
    }
    var _infoChart = (0,_to_array/* default */.Z)(infoChart), headerInfo = _infoChart[0], bodyInfo = _infoChart.slice(1);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (customInnerPage_module_default()).main_popup_img_wrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: (customInnerPage_module_default()).main_popup_img,
                    src: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/storage/").concat(domain, "/").concat(sizeChart === null || sizeChart === void 0 ? void 0 : sizeChart.image_path)),
                    alt: "".concat(sizeChart === null || sizeChart === void 0 ? void 0 : sizeChart.template_name, " Image")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                className: (customInnerPage_module_default()).chart_main,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                            children: Object.values(headerInfo).map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    children: item
                                }, index);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                        children: bodyInfo === null || bodyInfo === void 0 ? void 0 : bodyInfo.map(function(row, rowIndex) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                children: Object.values(row).map(function(cell, cellIndex) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        children: cell
                                    }, cellIndex);
                                })
                            }, rowIndex);
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var InnerPageProduct_SizeChartContent = (SizeChartContent);

// EXTERNAL MODULE: ./api/shop.ts + 1 modules
var shop = __webpack_require__(65564);
;// CONCATENATED MODULE: ./components/ForCWV/InnerPageProduct/CustomInfoPart.tsx











var CustomInfoPart = function(param) {
    var product = param.product, productName = param.productName, productSkuOptionName = param.productSkuOptionName, productSku = param.productSku, selectedCurrSymbol = param.selectedCurrSymbol, children = param.children, clientSidePrice = param.clientSidePrice, priceHtmlAvailable = param.priceHtmlAvailable, productShortDescOptionName = param.productShortDescOptionName, productShortDesc = param.productShortDesc, productOptions = param.productOptions, selectedCurrCode = param.selectedCurrCode, translationsData = param.translationsData, refsMap = param.refsMap, sizeChart = param.sizeChart, dbName = param.dbName, domain = param.domain;
    var ref, ref1;
    var openModalLayout = (0,es/* useSelector */.v9)(function(state) {
        return state.general.openModalLayout;
    });
    var customerToken = (0,es/* useSelector */.v9)(function(state) {
        return state.customer.token;
    });
    var ref2 = (0,react.useState)(null), promotionPrice = ref2[0], setPromotionPrice = ref2[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var isDonation = (product === null || product === void 0 ? void 0 : (ref = product.attribute_family) === null || ref === void 0 ? void 0 : ref.code) === "Donation";
    (0,react.useEffect)(function() {
        var cancelled = false;
        var fetchPromotionPrice = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var data, e;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(product === null || product === void 0 ? void 0 : product.id) || !selectedCurrCode) {
                                setPromotionPrice(null);
                                return [
                                    2
                                ];
                            }
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                shop["default"].getPromotionPrice(customerToken || "", "".concat(product.id), selectedCurrCode)
                            ];
                        case 2:
                            data = (_state.sent() || {}).data;
                            if (!cancelled) {
                                setPromotionPrice(data && typeof data === "object" ? data : null);
                            }
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            if (!cancelled) {
                                setPromotionPrice(null);
                            }
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchPromotionPrice() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchPromotionPrice();
        return function() {
            cancelled = true;
        };
    }, [
        customerToken,
        product === null || product === void 0 ? void 0 : product.id,
        selectedCurrCode
    ]);
    var productOptionsJSX = /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerPageProduct_CustomProductOptions, {
        product: product,
        productOptions: productOptions,
        translationsData: translationsData,
        refsMap: refsMap
    });
    var showProductOptionOrNot = {
        simple: {
            true: productOptionsJSX,
            false: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
        },
        virtual: {
            true: productOptionsJSX,
            false: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
        },
        configurable: {
            true: productOptionsJSX,
            false: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
        },
        downloadable: {
            true: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
            false: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
        },
        bundle: {
            true: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
            false: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
        }
    };
    var hasOptions = !!(productOptions === null || productOptions === void 0 ? void 0 : productOptions.length);
    var productOptionsContent = (ref1 = showProductOptionOrNot[product === null || product === void 0 ? void 0 : product.type]) === null || ref1 === void 0 ? void 0 : ref1[String(hasOptions)];
    var ShowPrice = function() {
        var formatPrice = function(key) {
            var finalKey = key !== null && key !== void 0 ? key : "price";
            var value = clientSidePrice[finalKey];
            if (!value) return null;
            var displayValue = value;
            if (finalKey === "cost") {
                if (selectedCurrCode !== "AMD") {
                    value = Number(value).toFixed(2);
                }
                displayValue = Number(value).toLocaleString();
            }
            if (selectedCurrCode === "AMD") {
                return "".concat(displayValue, " ").concat(selectedCurrSymbol);
            }
            return "".concat(selectedCurrSymbol, " ").concat(displayValue);
        };
        var className = "";
        var costTitle = null;
        var costBlock = null;
        if (clientSidePrice.cost) {
            className = (customInnerPage_module_default()).with_cost;
            costTitle = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (customInnerPage_module_default()).price_title,
                children: translationsData.Cash
            });
            costBlock = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (customInnerPage_module_default()).product__price,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (customInnerPage_module_default()).price_title,
                        children: translationsData.NonCash
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (customInnerPage_module_default()).price_value,
                        children: formatPrice("cost")
                    })
                ]
            });
        }
        var PriceValue = function(param) {
            var whichPriceKey = param.whichPriceKey;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (customInnerPage_module_default()).price_value,
                children: formatPrice(whichPriceKey)
            });
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: className,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (customInnerPage_module_default()).product__price,
                    children: [
                        costTitle,
                        clientSidePrice.specialPrice ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (customInnerPage_module_default())["product-card__new-price"],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceValue, {
                                        whichPriceKey: "specialPrice"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (customInnerPage_module_default())["product-card__old-price"],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceValue, {})
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceValue, {})
                    ]
                }),
                costBlock
            ]
        });
    };
    var PromotionPriceSummary = function() {
        if (!customerToken) return null;
        if (!(promotionPrice === null || promotionPrice === void 0 ? void 0 : promotionPrice.regular_price) || !(promotionPrice === null || promotionPrice === void 0 ? void 0 : promotionPrice.final_price)) return null;
        if (promotionPrice.final_price >= promotionPrice.regular_price) return null;
        var toNumber = function(value) {
            if (value === null || value === undefined || value === "") return null;
            var parsedValue = Number(String(value).replace(/,/g, ""));
            return Number.isFinite(parsedValue) ? parsedValue : null;
        };
        if (clientSidePrice === null || clientSidePrice === void 0 ? void 0 : clientSidePrice.specialPrice) {
            var promotionFinalPrice = toNumber(promotionPrice.final_price);
            var clientSpecialPrice = toNumber(clientSidePrice.specialPrice);
            if (promotionFinalPrice === null || clientSpecialPrice === null || promotionFinalPrice >= clientSpecialPrice) {
                return null;
            }
        }
        var formatPromotionPrice = function(value) {
            var numericValue = toNumber(value);
            if (numericValue === null) return null;
            var formattedValue = numericValue.toLocaleString(undefined, {
                minimumFractionDigits: selectedCurrCode === "AMD" ? 0 : 2,
                maximumFractionDigits: selectedCurrCode === "AMD" ? 0 : 2
            });
            if (selectedCurrCode === "AMD") {
                return "".concat(formattedValue, " ").concat(selectedCurrSymbol);
            }
            return "".concat(selectedCurrSymbol).concat(formattedValue);
        };
        var regularPrice = toNumber(promotionPrice.regular_price);
        var specialPrice = toNumber(promotionPrice.special_price);
        var finalPrice = toNumber(promotionPrice.final_price);
        var _promotion_price;
        var promotionPriceValue = toNumber((_promotion_price = promotionPrice.promotion_price) !== null && _promotion_price !== void 0 ? _promotion_price : promotionPrice.final_price);
        var shouldShowMyPrice = promotionPriceValue !== null && specialPrice ? promotionPriceValue < specialPrice : true;
        var computedSavings = shouldShowMyPrice && regularPrice ? "".concat(Math.round(((finalPrice || 0) - regularPrice) / regularPrice * 100), "%") : null;
        var rows = [
            {
                label: translationsData.RegularPrice,
                value: formatPromotionPrice(promotionPrice.regular_price)
            },
            {
                label: translationsData.DiscountedPrice,
                value: specialPrice !== null ? formatPromotionPrice(promotionPrice.special_price) : null
            },
            {
                label: translationsData.MyPrice,
                value: shouldShowMyPrice ? formatPromotionPrice(promotionPrice.final_price) : null
            },
            {
                label: translationsData.MySavings,
                value: shouldShowMyPrice ? computedSavings : null
            }, 
        ].filter(function(param) {
            var value = param.value;
            return !!value;
        });
        if (!rows.length) {
            return null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (customInnerPage_module_default()).promotion_price_summary,
            children: rows.map(function(param) {
                var label = param.label, value = param.value;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (customInnerPage_module_default()).promotion_price_summary__row,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: label
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: value
                        })
                    ]
                }, label);
            })
        });
    };
    var ShowSizeChart = function() {
        if (sizeChart) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (customInnerPage_module_default())["product-inner-chart-title"],
                        style: {
                            margin: "12px 0",
                            cursor: "pointer"
                        },
                        onClick: function() {
                            return dispatch((0,general/* openModalLayoutAction */.oJ)(true));
                        },
                        children: translationsData === null || translationsData === void 0 ? void 0 : translationsData.ViewSizeChart
                    }),
                    openModalLayout ? /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_ModalLayout, {
                        close: function() {
                            return dispatch((0,general/* openModalLayoutAction */.oJ)(false));
                        },
                        title: sizeChart === null || sizeChart === void 0 ? void 0 : sizeChart.template_name,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerPageProduct_SizeChartContent, {
                            sizeChart: sizeChart,
                            dbName: dbName,
                            domain: domain
                        })
                    }) : null
                ]
            });
        }
        return null;
    };
    var showShortDesc = {
        "true": /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (customInnerPage_module_default())["product-inner-description-title"],
            children: productShortDescOptionName
        }),
        "false": /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                style: {
                    textAlign: "left"
                },
                className: (customInnerPage_module_default()).product__name,
                children: productName
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: (customInnerPage_module_default()).product__sku,
                children: [
                    productSkuOptionName,
                    ": ",
                    productSku
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowPrice, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowSizeChart, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: priceHtmlAvailable
            }),
            showShortDesc["".concat((productShortDesc === null || productShortDesc === void 0 ? void 0 : productShortDesc.length) > 0)],
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PromotionPriceSummary, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: productShortDesc
                }
            }),
            !isDonation && productOptionsContent,
            children,
            isDonation && productOptionsContent
        ]
    });
};
/* harmony default export */ var InnerPageProduct_CustomInfoPart = (CustomInfoPart);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./store/token/index.js + 3 modules
var token = __webpack_require__(46607);
// EXTERNAL MODULE: ./store/cart/index.ts + 2 modules
var cart = __webpack_require__(7597);
// EXTERNAL MODULE: ./components/shared/ProductCard/helpers.ts
var helpers = __webpack_require__(77458);
// EXTERNAL MODULE: ./controllers/helpers.js
var controllers_helpers = __webpack_require__(68837);
;// CONCATENATED MODULE: ./components/ForCWV/InnerPageProduct/helpers.ts














var showBoxAboutDetails = {
    "true": {
        display: "block",
        className: ""
    },
    "false": {
        className: "only_one",
        display: "none"
    }
};
var isSelectedDetailSectionClass = function(description, detail) {
    return {
        "true": {
            first: "".concat((customInnerPage_module_default()).tab, " ").concat((customInnerPage_module_default()).tab_description),
            second: "".concat((customInnerPage_module_default()).tab, " ").concat((customInnerPage_module_default()).tab_detail, " ").concat((customInnerPage_module_default())["tab_detail-active"]),
            // display: "none"
            content: detail
        },
        "false": {
            first: "".concat((customInnerPage_module_default()).tab, " ").concat((customInnerPage_module_default()).tab_description, " ").concat((customInnerPage_module_default())["tab_description-active"]),
            second: "".concat((customInnerPage_module_default()).tab, " ").concat((customInnerPage_module_default()).tab_detail),
            // display: "block"
            content: description
        }
    };
};
var dangerOrSuccessStyleConfig = {
    "true": {
        "true": {
            className: "text-success",
            IntlKey: "ChooseOption"
        },
        "false": {
            className: "text-success",
            IntlKey: "InStock"
        }
    },
    "false": {
        "true": {
            className: "",
            IntlKey: "ChooseOption"
        },
        "false": {
            className: "text-danger",
            IntlKey: "OutOfStock"
        }
    }
};
var dangerOrSuccessStyleSimple = {
    "true": {
        className: "text-success",
        ItlKey: "InStock"
    },
    "false": {
        className: "text-danger",
        ItlKey: "OutOfStock"
    }
};
var addCartDivStyleToggleConfig = {
    "true": {
        "true": "button_disabled",
        "false": ""
    },
    "false": {
        "true": "button_disabled",
        "false": ""
    }
};
var addCartDivStyleToggleSimple = {
    "true": "",
    "false": "button_disabled"
};
var openedBoxStyles = {
    "true": {
        arrowClass: "drop_down_opened",
        display: "block"
    },
    "false": {
        arrowClass: "",
        display: "none"
    }
};
var concatFilters = {
    "false": {
        mainDivClass: "attr_fms",
        childDivClass: "other-list-main-fms"
    },
    "true": {
        mainDivClass: "attr_color_fms",
        childDivClass: "color-attr_fm"
    }
};
var swatchTypeHandlerClass = {
    "true": {
        "true": "input-check-color--white",
        "false": "input-check-color--white"
    },
    "false": {
        "true": "input-check-color--light",
        "false": ""
    }
};
var useFetchCartToken = function(cartToken) {
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        var fetchCartData = {
            "false": function() {
                fetch("/api/checkout/cart/token").then(function(response) {
                    return response.json();
                }).then(function(res) {
                    if (res.api_token) {
                        dispatch((0,token/* AddCartToken */.y)(res.api_token));
                    }
                }).catch(function(err) {
                    return console.error(err);
                });
            },
            "true": function() {}
        };
        fetchCartData["".concat(!!cartToken.cartToken)]();
    }, []);
};
var upCrossSellHandle = function(attr) {
    var dispatch = attr.dispatch, productId = attr.productId, selectedLocale = attr.selectedLocale, selectedRate = attr.selectedRate, product = attr.product;
    return {
        "true": {
            "true": function() {
                dispatch((0,general/* setPopupName */.Sq)("upsell"));
                dispatch((0,cart/* getUpOrCrossProd */.xM)(productId, "up-sell", selectedLocale, selectedRate));
                dispatch((0,general/* setTempData */.LH)([
                    product
                ]));
            },
            "false": function() {
                return upCrossSellHandle(attr)["true"]["true"]();
            }
        },
        "false": {
            "true": function() {
                dispatch((0,cart/* getUpOrCrossProd */.xM)(productId, "cross-sell", selectedLocale, selectedRate));
                dispatch((0,general/* setCrossValid */.TV)(true));
                dispatch((0,general/* setPopupName */.Sq)("crossSell"));
                dispatch((0,general/* setTempData */.LH)([
                    product
                ]));
            },
            "false": function() {}
        }
    };
};
var openUpCrossProd = function(attr) {
    var has_up_sell = attr.has_up_sell, has_cross_sell = attr.has_cross_sell, crossAttributes = (0,_object_without_properties/* default */.Z)(attr, [
        "has_up_sell",
        "has_cross_sell"
    ]);
    return upCrossSellHandle(crossAttributes)["".concat(!!parseFloat(String(has_up_sell)))]["".concat(!!parseFloat(String(has_cross_sell)))]();
};
var handleCardClick = function(attr) {
    var dispatch = attr.dispatch, product = attr.product, cartToken = attr.cartToken, customerToken = attr.customerToken, selectedLocale = attr.selectedLocale, selectedRate = attr.selectedRate, addToast = attr.addToast, _quantity = attr.quantity, quantity = _quantity === void 0 ? 1 : _quantity, links = attr.links, otherProps = (0,_object_without_properties/* default */.Z)(attr, [
        "dispatch",
        "product",
        "cartToken",
        "customerToken",
        "selectedLocale",
        "selectedRate",
        "addToast",
        "quantity",
        "links"
    ]);
    return {
        "true": {
            "true": {
                "true": function() {
                    openUpCrossProd((0,_object_spread/* default */.Z)({
                        dispatch: dispatch,
                        selectedRate: selectedRate,
                        selectedLocale: selectedLocale,
                        product: product
                    }, otherProps));
                },
                "false": function() {
                    openUpCrossProd((0,_object_spread/* default */.Z)({
                        dispatch: dispatch,
                        selectedRate: selectedRate,
                        selectedLocale: selectedLocale,
                        product: product
                    }, otherProps));
                }
            },
            "false": {
                "true": function() {
                    openUpCrossProd((0,_object_spread/* default */.Z)({
                        dispatch: dispatch,
                        selectedRate: selectedRate,
                        selectedLocale: selectedLocale,
                        product: product
                    }, otherProps));
                    (0,helpers/* addToCartEventPixel */.Gg)(product, quantity, selectedRate);
                    dispatch((0,cart/* cartAddItem */.rg)(product, quantity, cartToken, {
                        token: customerToken
                    }, selectedLocale, selectedRate.symbol, null, addToast, links));
                },
                "false": function() {
                    (0,helpers/* addToCartEventPixel */.Gg)(product, quantity, selectedRate);
                    dispatch((0,cart/* cartAddItem */.rg)(product, quantity, cartToken, {
                        token: customerToken
                    }, selectedLocale, selectedRate.symbol, null, addToast, links));
                }
            }
        },
        "false": {
            "true": {
                "true": function() {},
                "false": function() {}
            },
            "false": {
                "true": function() {},
                "false": function() {}
            }
        }
    };
};
var schemaProduct = function(asPath, productName, productDesc, productImgPath, productSku, productId, dbName, domain, schemaBrandName) {
    return {
        "@context": "https://schema.org/",
        "@type": "Product",
        "name": productName,
        "description": productDesc,
        "image": (0,helper/* domainUrl */.HJ)("".concat(dbName).concat(productImgPath)),
        "url": (0,helper/* domainUrl */.HJ)("".concat(dbName).concat(asPath)),
        "brand": {
            "@type": "Brand",
            "name": schemaBrandName
        },
        "review": {
            "@type": "Review",
            "name": "Organization Review",
            "reviewRating": {
                "@type": "Rating",
                "ratingValue": "0"
            },
            "author": {
                "@type": "Organization",
                "name": domain
            }
        },
        "productID": productId,
        "sku": productSku
    };
};
var formatOptionQuantityObj = function(concatCurrElem, item) {
    var _Math, _Math1;
    var minimumDefaultQty = (_Math = Math).min.apply(_Math, (0,_to_consumable_array/* default */.Z)(concatCurrElem.map(function(elem) {
        return +elem.optionDefaultQty;
    })));
    var minimumProductQty = (_Math1 = Math).min.apply(_Math1, (0,_to_consumable_array/* default */.Z)(concatCurrElem.map(function(elem) {
        return +elem.productQty;
    })));
    var totalPrice = concatCurrElem.reduce(function(total, param) {
        var price = param.price;
        return total + price;
    }, 0);
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
        id: concatCurrElem.map(function(el) {
            return el.id;
        }).flat(),
        productQty: minimumProductQty,
        optionDefaultQty: minimumDefaultQty,
        bundleOptionId: concatCurrElem[0].bundleOptionId,
        price: totalPrice
    });
};
var handleChangeOutsideForMulti = function(e, optionQuantity, setOptionQuantity) {
    var value = JSON.parse(e.target.value);
    var existThisVal = optionQuantity.find(function(option) {
        if (Array.isArray(option === null || option === void 0 ? void 0 : option.id)) {
            return option.id.some(function(elem) {
                return String(elem) === String(e.target.id);
            });
        } else {
            return String(option === null || option === void 0 ? void 0 : option.id) === e.target.id;
        }
    });
    if (existThisVal) {
        if (Array.isArray(existThisVal.id)) {
            if (existThisVal.id.length === 1) {
                setOptionQuantity(function(prevState) {
                    return prevState.filter(function(element) {
                        if (Array.isArray(element.id)) {
                            return String(element.id[0]) !== e.target.id;
                        }
                        return String(element.id) !== e.target.id;
                    });
                });
            } else {
                setOptionQuantity(function(prevState) {
                    return prevState.map(function(elem) {
                        if (Array.isArray(elem.id)) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, elem), {
                                id: elem.id.filter(function(lll) {
                                    return String(lll) !== e.target.id;
                                }),
                                price: elem.price - value.price
                            });
                        }
                        return elem;
                    });
                });
            }
        }
        setOptionQuantity(function(prevState) {
            return prevState.filter(function(lll) {
                return String(lll.id) !== e.target.id;
            });
        });
    } else {
        setOptionQuantity(function(prevState) {
            var currElement = prevState.filter(function(element) {
                return element.bundleOptionId === value.bundleOptionId;
            });
            if (currElement.length > 0) {
                var concatCurrElem = (0,_to_consumable_array/* default */.Z)(currElement).concat([
                    value
                ]);
                return prevState.map(function(item) {
                    if (currElement.find(function(it) {
                        return item.id === it.id;
                    })) {
                        return formatOptionQuantityObj(concatCurrElem, item);
                    }
                    return item;
                });
            }
            return (0,_to_consumable_array/* default */.Z)(prevState).concat([
                value
            ]);
        });
    }
};
var useCustomOptions = function(param) {
    var setClientSideProduct = param.setClientSideProduct, productMinPrice = param.productMinPrice, productSpecialPrice = param.productSpecialPrice, productPrice = param.productPrice, selectedRate = param.selectedRate, asPath = param.asPath, product = param.product, productSlug = param.productSlug;
    var optionValues = (0,es/* useSelector */.v9)(function(state) {
        return state.product.optionValues;
    });
    var refsMap = (0,react.useRef)(new Map());
    var customOptions = {
        "customizable_options": optionValues.reduce(function(result, value) {
            result["".concat(value.id)] = value.optionId;
            return result;
        }, {})
    };
    var handleAmdPrice = function(param, price) {
        var currCode = param.code;
        var currentCurrCodeIsAmdOrRub = currCode.toLowerCase() === "amd" || currCode.toLowerCase() === "rub";
        if (!currentCurrCodeIsAmdOrRub) {
            return Number(price).toFixed(2);
        }
        return +price;
    };
    (0,react.useEffect)(function() {
        var priceArray = optionValues.map(function(element) {
            var ref;
            if ((product === null || product === void 0 ? void 0 : (ref = product.attribute_family) === null || ref === void 0 ? void 0 : ref.code) === "Donation") {
                return parseFloat(element.label);
            }
            return parseFloat(element.price);
        });
        var concatenatedString = priceArray.reduce(function(accumulator, currentValue) {
            return accumulator + currentValue;
        }, 0).toString() + ".000";
        setClientSideProduct(function(prev) {
            var newProductFlat = (0,_object_spread/* default */.Z)({}, prev.flats[0]);
            var defaultMinPrice = productMinPrice ? parseFloat(productMinPrice) : 0;
            var defaultSpecialPrice = productSpecialPrice ? parseFloat(productSpecialPrice) : 0;
            var defaultPrice = productPrice ? parseFloat(productPrice) : 0;
            var newPrice = defaultPrice + parseFloat(concatenatedString) || 0;
            newProductFlat.price = (0,controllers_helpers.formatPrice)(newPrice, selectedRate).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            var newFlatPriceHandle = {
                minToggle: {
                    "true": function() {
                        var newMinPrice = defaultMinPrice + parseFloat(concatenatedString) || 0;
                        newProductFlat.min_price = (0,controllers_helpers.formatPrice)(newMinPrice, selectedRate).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    },
                    "false": function() {}
                },
                specialToggle: {
                    "true": function() {
                        var newSpecialPrice = defaultSpecialPrice + parseFloat(concatenatedString) || 0;
                        newProductFlat.special_price = (0,controllers_helpers.formatPrice)(newSpecialPrice, selectedRate).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    },
                    "false": function() {}
                }
            };
            newFlatPriceHandle.minToggle["".concat(productMinPrice !== null)]();
            newFlatPriceHandle.specialToggle["".concat(!!productSpecialPrice)]();
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                flats: [
                    newProductFlat
                ]
            });
        });
        localStorage.setItem("customOptions", JSON.stringify(customOptions));
    }, [
        optionValues,
        asPath,
        productSlug
    ]);
    return {
        customOptions: customOptions,
        refsMap: refsMap
    };
};
var configInActiveVariantHelper = function(param) {
    var setConfigAttributesCSR = param.setConfigAttributesCSR, configAttributesCSR = param.configAttributesCSR, configVariants = param.configVariants, configAttributes = param.configAttributes, updatedFiltered = param.updatedFiltered;
    if (Object.values(updatedFiltered).length === configAttributesCSR.length - 1 || Object.values(updatedFiltered).length === configAttributesCSR.length) {
        var removalObject = null;
        configVariants.forEach(function(variant) {
            if (variant.flats[0].status === 0 || variant.qty[0] === 0) {
                var filterOnlyInt = variant.product_attribute_values.filter(function(prAttr) {
                    return prAttr.integer_value && configAttributesCSR.some(function(iii) {
                        var ref;
                        return ((ref = iii === null || iii === void 0 ? void 0 : iii.attributes_values[0]) === null || ref === void 0 ? void 0 : ref.id) === (prAttr === null || prAttr === void 0 ? void 0 : prAttr.attribute_id);
                    });
                });
                var filterInActiveVariantAttr1 = filterOnlyInt.filter(function(prAttr) {
                    return String(updatedFiltered[prAttr.attribute_id]) !== String(prAttr.integer_value);
                });
                if (filterInActiveVariantAttr1.length === 1) {
                    removalObject = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, removalObject), (0,_define_property/* default */.Z)({}, filterInActiveVariantAttr1[0].attribute_id, filterInActiveVariantAttr1[0].integer_value));
                }
                if (removalObject) {
                    setConfigAttributesCSR(function(prevState) {
                        return prevState.map(function(confAttr) {
                            var ref, ref1;
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, confAttr), {
                                attribute_options: confAttr === null || confAttr === void 0 ? void 0 : (ref = confAttr.attribute_options) === null || ref === void 0 ? void 0 : ref.map(function(attrOption) {
                                    var ref, ref1;
                                    if ((removalObject === null || removalObject === void 0 ? void 0 : removalObject[confAttr === null || confAttr === void 0 ? void 0 : (ref = confAttr.attributes_values) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.id]) !== String(attrOption.id)) {
                                        return attrOption;
                                    } else {
                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attrOption), {
                                            disabled: true
                                        });
                                    }
                                }),
                                attributes_values: [
                                    (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, confAttr === null || confAttr === void 0 ? void 0 : confAttr.attributes_values[0]), {
                                        attribute_options: (ref1 = confAttr === null || confAttr === void 0 ? void 0 : confAttr.attributes_values[0]) === null || ref1 === void 0 ? void 0 : ref1.attribute_options.map(function(attrOption) {
                                            var ref, ref1;
                                            if ((removalObject === null || removalObject === void 0 ? void 0 : removalObject[confAttr === null || confAttr === void 0 ? void 0 : (ref = confAttr.attributes_values) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.id]) !== String(attrOption.id)) {
                                                return attrOption;
                                            } else {
                                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attrOption), {
                                                    disabled: true
                                                });
                                            }
                                        })
                                    })
                                ]
                            });
                        });
                    });
                } else {
                    setConfigAttributesCSR(configAttributes);
                }
            }
        });
    }
};
var configNotExistVariantHelper = function(param) {
    var setConfigAttributesCSR = param.setConfigAttributesCSR, configAttributesCSR = param.configAttributesCSR, variantProductIsSelected = param.variantProductIsSelected, seperatedAttrs = param.seperatedAttrs, filtered = param.filtered;
    var filteredValArr = Object.entries(seperatedAttrs).filter(function(elem) {
        return Object.entries(filtered).every(function(eachFilElem) {
            return String(elem[1][eachFilElem[0]]) === String(eachFilElem[1]);
        });
    });
    var removalObject = Object.values(Object.assign(Object.fromEntries(filteredValArr)));
    var optionToggle = function(attrOption) {
        var findDisabledOption = removalObject.some(function(elem) {
            var selectedVariantFiltersOpen = Object.entries(filtered).some(function(eachFil, _, array) {
                var filteredArr = array.filter(function(asd) {
                    return String(asd[0]) !== String(eachFil[0]);
                });
                return Object.values(seperatedAttrs).filter(function(elem) {
                    return filteredArr.every(function(asd) {
                        return String(elem[asd[0]]) === String(asd[1]);
                    });
                }).map(function(oji) {
                    var uppOji = Object.entries(oji).filter(function(asd) {
                        return !filteredArr.some(function(fil) {
                            return fil[0] === asd[0];
                        });
                    });
                    return Object.fromEntries(uppOji);
                }).some(function(elem) {
                    return String(elem[attrOption.attribute_id]) === String(attrOption.id);
                });
            });
            if (Object.values(filtered).length === configAttributesCSR.length || variantProductIsSelected) {
                return selectedVariantFiltersOpen;
            }
            if (filtered.hasOwnProperty(attrOption.attribute_id) && Object.values(filtered).length !== configAttributesCSR.length - 1) {
                return true;
            }
            return String(elem[attrOption.attribute_id]) === String(attrOption.id);
        });
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attrOption), {
            disabled: !findDisabledOption
        });
    };
    setConfigAttributesCSR(function(prevState) {
        return prevState.map(function(confAttr) {
            var ref, ref1;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, confAttr), {
                attribute_options: confAttr === null || confAttr === void 0 ? void 0 : (ref = confAttr.attribute_options) === null || ref === void 0 ? void 0 : ref.map(optionToggle),
                attributes_values: [
                    (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, confAttr === null || confAttr === void 0 ? void 0 : confAttr.attributes_values[0]), {
                        attribute_options: (ref1 = confAttr === null || confAttr === void 0 ? void 0 : confAttr.attributes_values[0]) === null || ref1 === void 0 ? void 0 : ref1.attribute_options.map(optionToggle)
                    })
                ]
            });
        });
    });
};

// EXTERNAL MODULE: ./components/ForCWV/InnerPageProduct/CustomProductGallery.tsx
var CustomProductGallery = __webpack_require__(81907);
;// CONCATENATED MODULE: ./components/ForCWV/InnerPageProduct/CustomProduct.tsx
























var CustomProduct = function(param) {
    var dbName = param.dbName, productSlug = param.productSlug, domain = param.domain, selectedRate = param.selectedRate, product = param.product, backOrderValue = param.backOrderValue, customerGroupPrices = param.customerGroupPrices, translationsData = param.translationsData, selectedLocale = param.selectedLocale, schemaBrandName = param.schemaBrandName, showDetailsInFront = param.showDetailsInFront, showBuilderComponents = param.showBuilderComponents, showBuilderData = param.showBuilderData, requestFormInfo = param.requestFormInfo, requestFormDetails = param.requestFormDetails, sizeChart = param.sizeChart;
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)(product), clientSideProduct = ref3[0], setClientSideProduct = ref3[1];
    var ref4 = (0,react.useState)({
        element: [],
        display: "none"
    }), resultFilterGroup = ref4[0], setResultFilterGroup = ref4[1];
    var tmp = product.flats, ref5 = (0,_sliced_to_array/* default */.Z)(tmp === void 0 ? [] : tmp, 1), tmp1 = ref5[0], ref6 = tmp1 === void 0 ? {} : tmp1, tmp2 = ref6.name, productName = tmp2 === void 0 ? "" : tmp2, tmp3 = ref6.description, productDesc = tmp3 === void 0 ? "" : tmp3, tmp4 = ref6.min_price, productMinPrice = tmp4 === void 0 ? null : tmp4, tmp5 = ref6.special_price, productSpecialPrice = tmp5 === void 0 ? null : tmp5, tmp6 = ref6.short_description, productShortDesc = tmp6 === void 0 ? "" : tmp6, tmp7 = ref6.price, productPrice = tmp7 === void 0 ? null : tmp7, tmp8 = ref6.price_html, productPriceHtml = tmp8 === void 0 ? null : tmp8, tmp9 = ref6.min_qty, productMinQtyServer = tmp9 === void 0 ? 1 : tmp9, tmp10 = product.images, ref7 = (0,_sliced_to_array/* default */.Z)(tmp10 === void 0 ? [] : tmp10, 1), tmp11 = ref7[0], productImgPath = tmp11 === void 0 ? "" : tmp11, productId = product.id, tmp12 = product.sku, productSku = tmp12 === void 0 ? "" : tmp12, tmp13 = product.details, productDetails = tmp13 === void 0 ? [] : tmp13, tmp14 = product.sku_option, ref8 = tmp14 === void 0 ? {} : tmp14, tmp15 = ref8.name, productSkuOptionName = tmp15 === void 0 ? "SKU" : tmp15, tmp16 = product.short_description_option, ref9 = tmp16 === void 0 ? {} : tmp16, tmp17 = ref9.name, productShortDescOptionName = tmp17 === void 0 ? "" : tmp17, tmp18 = product.description_option, ref10 = tmp18 === void 0 ? {} : tmp18, tmp19 = ref10.name, productDescOptionName = tmp19 === void 0 ? "" : tmp19, _product_options = product.product_options, product_options = _product_options === void 0 ? [] : _product_options, _qty = (0,_sliced_to_array/* default */.Z)(product.qty, 1), productInitialQty = _qty[0];
    var productMinQty = !!!productMinQtyServer || !!!+productMinQtyServer ? 1 : productMinQtyServer;
    var ref11 = (0,react.useState)(+productMinQty || 1), productQuantity = ref11[0], setProductQuantity = ref11[1];
    var ref12 = (0,react.useState)(product === null || product === void 0 ? void 0 : product.qty[0]), maxQty = ref12[0], setMaxQty = ref12[1];
    var cart = (0,es/* useSelector */.v9)(function(state) {
        return state.cart;
    });
    var findExistItem = cart === null || cart === void 0 ? void 0 : (ref = cart.items) === null || ref === void 0 ? void 0 : ref.find(function(elem) {
        var ref;
        return (elem === null || elem === void 0 ? void 0 : (ref = elem.product) === null || ref === void 0 ? void 0 : ref.id) === productId;
    });
    (0,react.useEffect)(function() {
        var ref, ref1;
        if (+backOrderValue) {
            setMaxQty(50000);
        } else if (cart === null || cart === void 0 ? void 0 : (ref = cart.items) === null || ref === void 0 ? void 0 : ref.length) {
            if (findExistItem) {
                setMaxQty(Number(+(product === null || product === void 0 ? void 0 : product.qty[0]) - +(findExistItem === null || findExistItem === void 0 ? void 0 : findExistItem.quantity)));
            }
        } else if (!(cart === null || cart === void 0 ? void 0 : (ref1 = cart.items) === null || ref1 === void 0 ? void 0 : ref1.length)) {
            setMaxQty(Number(product === null || product === void 0 ? void 0 : product.qty[0]));
        }
    }, [
        findExistItem === null || findExistItem === void 0 ? void 0 : findExistItem.quantity
    ]);
    (0,react.useEffect)(function() {
        setProductQuantity(+productMinQty);
        setClientSideProduct(product);
    }, [
        productSlug
    ]);
    var ref13 = (0,react.useState)(!productDesc), isSelectDetail = ref13[0], setIsSelectDetail = ref13[1];
    var cartToken = (0,es/* useSelector */.v9)(function(state) {
        return state.cartToken;
    });
    var ref14 = (0,es/* useSelector */.v9)(function(state) {
        return state.customer;
    }), customerGroupId = ref14.customerGroupId, customerToken = ref14.token;
    var signed = (0,es/* useSelector */.v9)(function(state) {
        return state.customer.authenticated;
    });
    var wishlist = (0,es/* useSelector */.v9)(function(state) {
        return state.wishlist;
    });
    var isProductInWishList = wishlist === null || wishlist === void 0 ? void 0 : wishlist.find(function(item) {
        return item.id === productId;
    });
    var ref15 = (0,react.useState)(/*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* HeartSvg */.xO, {})), wishIcon = ref15[0], setWishIcon = ref15[1];
    (0,react.useEffect)(function() {
        setWishIcon(!!isProductInWishList ? /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* HeartActive */.wL, {
            className: (customInnerPage_module_default())["inner-wishlist"]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* HeartSvg */.xO, {}));
    }, [
        isProductInWishList
    ]);
    var dispatch = (0,es/* useDispatch */.I0)();
    var optionValues = (0,es/* useSelector */.v9)(function(state) {
        return state.product.optionValues;
    });
    var toast = (0,useToast/* useToast */.p)();
    var ref16 = (0,next_router.useRouter)(), asPath = ref16.asPath, routerPush = ref16.push;
    var rootRef = (0,react.useRef)(null);
    var isProductInStock = product.qty[0] > 0 || !!parseFloat(backOrderValue);
    var addToast = function(error) {
        if (error) {
            toast.open(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "d-flex chek-fms",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* FailSvg */.as, {}),
                    translationsData.ProductNotAvailable
                ]
            }));
        } else {
            if (isProductInStock) {
                toast.open(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "d-flex chek-fms",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* CheckToastSvg */.xQ, {}),
                        translationsData.ToastAddToCart
                    ]
                }));
            }
        }
    };
    (0,react.useEffect)(function() {
        var ref;
        var handleGroupPriceDisplay = {
            "true": "flex",
            "false": "none"
        };
        setResultFilterGroup({
            element: updatedProductGroupToggle(customerGroupPrices, customerGroupId, product, true, (selectedRate === null || selectedRate === void 0 ? void 0 : (ref = selectedRate.exchange_rate) === null || ref === void 0 ? void 0 : ref.rate) || "1"),
            display: handleGroupPriceDisplay["".concat(!!customerGroupPrices.length)]
        });
    }, [
        productSlug
    ]);
    var schema = schemaProduct(asPath, productName, productDesc, productImgPath, productSku, productId, dbName, domain, schemaBrandName);
    var ref17 = useCustomOptions({
        setClientSideProduct: setClientSideProduct,
        productMinPrice: productMinPrice,
        productSpecialPrice: productSpecialPrice,
        productPrice: productPrice,
        selectedRate: selectedRate,
        asPath: asPath,
        productSlug: productSlug
    }), customOptions = ref17.customOptions, refsMap = ref17.refsMap;
    useFetchCartToken(cartToken);
    var selectTab = function(e) {
        setIsSelectDetail(e.target.id === "detail");
    };
    var quantityColumnHandler = function(title, isQuantity) {
        var handleQuantity = function(param) {
            var qty = param.qty, value = param.value;
            return {
                "true": {
                    divTableStyle: {
                        background: "#EFEFEF"
                    },
                    priceClassToggle: "quantity_item_span",
                    priceSpan: qty,
                    titleSpan: translationsData === null || translationsData === void 0 ? void 0 : translationsData.AndMore
                },
                "false": {
                    divTableStyle: {},
                    priceClassToggle: "price_item_span",
                    priceSpan: "".concat(selectedRate === null || selectedRate === void 0 ? void 0 : selectedRate.symbol).concat(value),
                    titleSpan: ""
                }
            };
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (customInnerPage_module_default()).quantity_table_row,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: handleQuantity({
                        qty: "",
                        value: ""
                    })["".concat(isQuantity)].divTableStyle,
                    className: (customInnerPage_module_default()).quantity_table_item,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (customInnerPage_module_default()).quantity_item_span,
                        children: translationsData === null || translationsData === void 0 ? void 0 : translationsData[title]
                    })
                }),
                resultFilterGroup.element.map(function(groupItem) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: handleQuantity(groupItem)["".concat(isQuantity)].divTableStyle,
                        className: (customInnerPage_module_default()).quantity_table_item,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: (customInnerPage_module_default())[handleQuantity(groupItem)["".concat(isQuantity)].priceClassToggle],
                            children: [
                                handleQuantity(groupItem)["".concat(isQuantity)].priceSpan,
                                " ",
                                handleQuantity(groupItem)["".concat(isQuantity)].titleSpan
                            ]
                        })
                    });
                })
            ]
        });
    };
    var handleWishIconClick = function(e) {
        e.preventDefault();
        if (!signed) {
            toast.open(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "d-flex faild-toast-fms",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* FailSvg */.as, {}),
                    translationsData.ToastSignIn
                ]
            }));
        } else {
            !!isProductInWishList ? dispatch((0,wishlistActions/* wishlistRemoveItem */.uv)(product.id)) : dispatch((0,wishlistActions/* wishlistAddItem */.c8)(product, selectedLocale));
            var toastChildren = {
                "true": {
                    svg: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* FailSvg */.as, {}),
                    title: translationsData === null || translationsData === void 0 ? void 0 : translationsData.ToastWishListRemove
                },
                "false": {
                    svg: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* CheckToastSvg */.xQ, {}),
                    title: translationsData === null || translationsData === void 0 ? void 0 : translationsData.ToastWishList
                }
            };
            toast.open(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "d-flex faild-toast-fms",
                children: [
                    toastChildren["".concat(!!isProductInWishList)].svg,
                    toastChildren["".concat(!!isProductInWishList)].title
                ]
            }));
        }
    };
    var priceHtmlAvailable = {
        "true": (ref1 = product === null || product === void 0 ? void 0 : product.flats[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.price_html) === null || ref2 === void 0 ? void 0 : ref2.map(function(e, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (customInnerPage_module_default()).product_price_html,
                children: e
            }, i);
        }),
        "false": /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
    };
    var handleZero = function(value) {
        return {
            true: +value,
            false: 1
        };
    };
    var handleCustomerGroupPrice = {
        "true": /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerPageProduct_CustomQuantityTable, {
            QuantityDiscount_INTL: translationsData === null || translationsData === void 0 ? void 0 : translationsData.QuantityDiscount,
            quantityColumnHandler: quantityColumnHandler,
            displayFilterGroup: resultFilterGroup.display
        }),
        "false": null
    };
    var isButtonDisabled = {
        "true": !!!+backOrderValue,
        "false": false
    };
    var descriptions = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "product-inner-long-description",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                paddingLeft: "30px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: productDesc
                }
            })
        })
    });
    var details = /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerPageProduct_CustomDetails, {
        details: productDetails,
        isSelectDetail: isSelectDetail,
        showDetailsInFront: showDetailsInFront,
        translationsData: translationsData,
        dbName: dbName,
        domain: domain
    });
    var handleAddCartClickLocal = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var quantity, filterRequiredOptions, everyItemExist;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        quantity = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : 1;
                        if ((product_options === null || product_options === void 0 ? void 0 : product_options.length) > 0) {
                            filterRequiredOptions = product_options.filter(function(option) {
                                return Number(option === null || option === void 0 ? void 0 : option.required);
                            });
                            if (filterRequiredOptions === null || filterRequiredOptions === void 0 ? void 0 : filterRequiredOptions.length) {
                                everyItemExist = filterRequiredOptions === null || filterRequiredOptions === void 0 ? void 0 : filterRequiredOptions.filter(function(item) {
                                    return !optionValues.some(function(option) {
                                        return option.id === item.id;
                                    });
                                }).map(function(item) {
                                    return item.id;
                                });
                                if (everyItemExist.length > 0) {
                                    dispatch((0,store_product/* setNotFilledOptionsAction */.WM)(everyItemExist));
                                    return [
                                        2
                                    ];
                                }
                            }
                        }
                        dispatch((0,store_product/* setNotFilledOptionsAction */.WM)([]));
                        return [
                            4,
                            (0,helpers/* handleAddCard */.x)({
                                openUpCrossProd: function() {
                                    return (0,helpers/* openUpCrossProd */.Vr)({
                                        dispatch: dispatch,
                                        productId: productId,
                                        selectedLocale: selectedLocale,
                                        selectedRate: selectedRate,
                                        product: product
                                    });
                                },
                                dispatch: dispatch,
                                data: {
                                    product: product,
                                    quantity: quantity,
                                    cartToken: cartToken,
                                    customer: {
                                        token: customerToken
                                    },
                                    selectedLocale: selectedLocale,
                                    selectedCurrCode: selectedRate.code,
                                    optionsObject: Object.keys(customOptions === null || customOptions === void 0 ? void 0 : customOptions.customizable_options).length > 0 ? customOptions : null,
                                    addToast: addToast
                                },
                                routerPush: routerPush,
                                isProductInStock: isProductInStock
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function handleAddCartClickLocal() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: schema.name,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(schema)
                },
                defer: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (customInnerPage_module_default()).product__content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomProductGallery/* default */.Z, {
                                images: product.images,
                                dbName: dbName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (customInnerPage_module_default()).product__info,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerPageProduct_CustomInfoPart, {
                                        product: product,
                                        productName: productName,
                                        productSkuOptionName: productSkuOptionName,
                                        productSku: productSku,
                                        selectedCurrSymbol: selectedRate === null || selectedRate === void 0 ? void 0 : selectedRate.symbol,
                                        selectedCurrCode: selectedRate === null || selectedRate === void 0 ? void 0 : selectedRate.code,
                                        clientSidePrice: {
                                            price: clientSideProduct.flats[0].price,
                                            specialPrice: clientSideProduct.flats[0].special_price || 0,
                                            cost: clientSideProduct.flats[0].cost
                                        },
                                        priceHtmlAvailable: priceHtmlAvailable["".concat(!!productPriceHtml)],
                                        productShortDescOptionName: productShortDescOptionName,
                                        productShortDesc: productShortDesc,
                                        productOptions: product_options,
                                        translationsData: translationsData,
                                        refsMap: refsMap,
                                        sizeChart: sizeChart,
                                        dbName: dbName,
                                        domain: domain,
                                        children: handleCustomerGroupPrice["".concat(resultFilterGroup.element.length > 0)]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (customInnerPage_module_default()).sidebar__details,
                                        children: !showDetailsInFront && !!productDetails.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerPageProduct_CustomDetails, {
                                            details: productDetails,
                                            isSelectDetail: isSelectDetail,
                                            showDetailsInFront: true,
                                            translationsData: translationsData,
                                            dbName: dbName,
                                            domain: domain
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: "".concat((customInnerPage_module_default()).product__meta, " ").concat((customInnerPage_module_default()).simple__meta),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: (customInnerPage_module_default())["product__meta-availability"],
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: dangerOrSuccessStyleSimple["".concat(isProductInStock)].className,
                                                    style: {
                                                        fontSize: "18px"
                                                    },
                                                    children: translationsData === null || translationsData === void 0 ? void 0 : translationsData[dangerOrSuccessStyleSimple["".concat(isProductInStock)].ItlKey]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((customInnerPage_module_default())["product__actions-item"], " ").concat((customInnerPage_module_default())["product-inner-quantity"]),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputNumber/* default */.Z, {
                                                    id: "product-quantity",
                                                    "aria-label": "Quantity",
                                                    className: (customInnerPage_module_default()).product__quantity,
                                                    size: "lg",
                                                    min: handleZero(productMinQty)["".concat(!!productMinQty)],
                                                    max: maxQty,
                                                    value: handleZero(productQuantity)["".concat(!!productQuantity)],
                                                    onChange: function(quantity) {
                                                        if (quantity > maxQty) {
                                                            setProductQuantity(maxQty);
                                                        } else {
                                                            setProductQuantity(quantity);
                                                        }
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerPageProduct_CustomSideBar, {
                                        ProductAddToCart_INTL: translationsData === null || translationsData === void 0 ? void 0 : translationsData.AddToCartButtonTitle,
                                        actionClassName: addCartDivStyleToggleSimple["".concat(isProductInStock)],
                                        handleCardClick: handleAddCartClickLocal,
                                        isButtonDisabled: isButtonDisabled["".concat(productInitialQty === 0)],
                                        wishListButtonClick: handleWishIconClick,
                                        wishIconClicked: wishIcon,
                                        minimalQty: handleZero(productMinQty)["".concat(!!productMinQty)],
                                        maximalQty: maxQty,
                                        inpValQuantity: handleZero(productQuantity)["".concat(!!productQuantity)],
                                        setQuantity: setProductQuantity,
                                        requestFormInfo: requestFormInfo,
                                        requestFormDetails: requestFormDetails
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerPageProduct_CustomSocialLinks, {
                                        dbName: dbName,
                                        domain: domain,
                                        productSlug: productSlug
                                    })
                                ]
                            })
                        ]
                    }),
                    showBuilderComponents(2)["".concat(showBuilderData)],
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerPageProduct_CustomDetailTabButtons, {
                        boxAboutDetailsClass: showBoxAboutDetails["".concat(showDetailsInFront)],
                        isSelectedDetailSectionClass: isSelectedDetailSectionClass(descriptions, details)["".concat(isSelectDetail)],
                        productDescOptionName: productDescOptionName,
                        Details_INTL: translationsData === null || translationsData === void 0 ? void 0 : translationsData.Details,
                        selectTab: selectTab,
                        showDescription: !!productDesc,
                        showDetailsInFront: showDetailsInFront
                    }),
                    isSelectedDetailSectionClass(descriptions, details)["".concat(isSelectDetail)].content
                ]
            })
        ]
    });
};
/* harmony default export */ var InnerPageProduct_CustomProduct = (CustomProduct);

;// CONCATENATED MODULE: ./components/ForCWV/InnerPageProduct/CustomConfigurableFilters.tsx









var ColorLayout = function(param) {
    var colorOrNot = param.colorOrNot, children = param.children, divId = param.divId, swatch_value = param.swatch_value, colorsStyle = param.colorsStyle;
    var colorOrNotLayoutHandle = {
        "true": /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (customInnerPage_module_default())["filter-color__item"],
            id: divId,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "\n                    ".concat((customInnerPage_module_default())["filter-color__check"], "\n                    ").concat((customInnerPage_module_default())["input-check-color"], "\n                    ").concat((customInnerPage_module_default())[swatchTypeHandlerClass["".concat(swatch_value === "white")]["".concat(swatch_value === "light")]], "\n                "),
                style: {
                    color: "".concat(colorsStyle).toLowerCase()
                },
                children: children
            })
        }),
        "false": /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
            children: children
        })
    };
    return colorOrNotLayoutHandle["".concat(colorOrNot)];
};
var CustomConfigurableFilters = function(param) {
    var handleChangeConfig = param.handleChangeConfig, configurableData = param.configurableData, filtered = param.filtered;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (customInnerPage_module_default()).config_filters,
        children: configurableData.map(function(attributes, index) {
            var _ref = attributes || {}, _attributes_values = (0,_sliced_to_array/* default */.Z)(_ref.attributes_values, 1), ref = _attributes_values[0], tmp = ref.translations, ref1 = (0,_sliced_to_array/* default */.Z)(tmp === void 0 ? [] : tmp, 1), tmp1 = ref1[0], ref2 = tmp1 === void 0 ? {} : tmp1, tmp2 = ref2.name, widgetName = tmp2 === void 0 ? "" : tmp2, code = ref.code, attribute_options = ref.attribute_options, selectedAttributeObj = (0,_object_without_properties/* default */.Z)(_ref, [
                "attributes_values"
            ]);
            var ref3 = (0,_sliced_to_array/* default */.Z)(Object.keys(selectedAttributeObj), 1), selectedAttribute = ref3[0];
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((customInnerPage_module_default())[concatFilters["".concat(code === "color")].mainDivClass], " ").concat((customInnerPage_module_default()).attr_space),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (customInnerPage_module_default()).attr_label_size,
                        children: widgetName + " :"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (customInnerPage_module_default())[concatFilters["".concat(code === "color")].childDivClass],
                        children: attribute_options.map(function(param, i) {
                            var _translations = (0,_sliced_to_array/* default */.Z)(param.translations, 1), ref = _translations[0], _label = ref.label, label = _label === void 0 ? [] : _label, id = param.id, attrID = param.attribute_id, swatch_value = param.swatch_value, colorsStyle = param.colorsStyle, disabled = param.disabled;
                            var propsWithColor = {
                                "true": {
                                    labelProps: {
                                        className: (customInnerPage_module_default())["input-check-color__body"]
                                    },
                                    inputClassName: "input-check-color__input"
                                },
                                "false": {
                                    labelProps: {
                                        htmlFor: code + id,
                                        id: id + code
                                    },
                                    inputClassName: "other-radio__input"
                                }
                            };
                            if (!attributes[selectedAttribute].some(function(el) {
                                return el === id;
                            })) return null;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorLayout, {
                                colorOrNot: code === "color",
                                divId: id + code,
                                swatch_value: swatch_value,
                                colorsStyle: colorsStyle,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, propsWithColor["".concat(code === "color")].labelProps), {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            hidden: true,
                                            id: code + id,
                                            className: (customInnerPage_module_default())[propsWithColor["".concat(code === "color")].inputClassName],
                                            type: "radio",
                                            name: code,
                                            value: id,
                                            checked: filtered[attrID] === id,
                                            onClick: function() {
                                                return handleChangeConfig({
                                                    attribute_id: attrID,
                                                    id: id
                                                });
                                            },
                                            //TODO !!! if we dont need this remove
                                            readOnly: true,
                                            disabled: disabled
                                        }),
                                        (function() {
                                            return {
                                                "false": function() {
                                                    var labelShowToggle = {
                                                        "true": label.slice(0, 13) + "...",
                                                        "false": label
                                                    };
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (customInnerPage_module_default())["label-attr__code"],
                                                        children: labelShowToggle["".concat(label.length > 16)]
                                                    });
                                                },
                                                "true": function() {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (customInnerPage_module_default())["input-check-color__box"]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* Check12x9Svg */.zE, {
                                                                className: (customInnerPage_module_default())["input-check-color__icon"]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (customInnerPage_module_default())["input-check-color__stick"]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (customInnerPage_module_default())["input-check-color__stick"],
                                                                style: {
                                                                    transform: "rotateZ(-45deg)"
                                                                }
                                                            })
                                                        ]
                                                    });
                                                }
                                            };
                                        })()["".concat(code === "color")]()
                                    ]
                                }))
                            }, i);
                        })
                    })
                ]
            }, index);
        })
    });
};
/* harmony default export */ var InnerPageProduct_CustomConfigurableFilters = (CustomConfigurableFilters);

;// CONCATENATED MODULE: ./components/ForCWV/InnerPageProduct/CustomConfig.tsx



























var CustomConfig = function(param) {
    var dbName = param.dbName, productSlug = param.productSlug, domain = param.domain, selectedRate = param.selectedRate, product = param.product, backOrderValue = param.backOrderValue, translationsData = param.translationsData, selectedLocale = param.selectedLocale, schemaBrandName = param.schemaBrandName, showDetailsInFront = param.showDetailsInFront, showBuilderComponents = param.showBuilderComponents, showBuilderData = param.showBuilderData, requestFormDetails = param.requestFormDetails, requestFormInfo = param.requestFormInfo, sizeChart = param.sizeChart;
    var ref, ref1, ref2, ref3;
    var tmp = product.flats, ref4 = (0,_sliced_to_array/* default */.Z)(tmp === void 0 ? [] : tmp, 1), tmp1 = ref4[0], ref5 = tmp1 === void 0 ? {} : tmp1, tmp2 = ref5.name, productName = tmp2 === void 0 ? "" : tmp2, tmp3 = ref5.description, productDesc = tmp3 === void 0 ? "" : tmp3, tmp4 = ref5.price_html, productPriceHtml = tmp4 === void 0 ? null : tmp4, tmp5 = ref5.min_qty, productMinQtyServer = tmp5 === void 0 ? 1 : tmp5, tmp6 = product.details, productDetails = tmp6 === void 0 ? [] : tmp6, tmp7 = product.images, ref6 = (0,_sliced_to_array/* default */.Z)(tmp7 === void 0 ? [] : tmp7, 1), tmp8 = ref6[0], ref7 = tmp8 === void 0 ? {} : tmp8, tmp9 = ref7.path, productImgPath = tmp9 === void 0 ? "" : tmp9, productId = product.id, tmp10 = product.sku, productSku = tmp10 === void 0 ? "" : tmp10, tmp11 = product.variants, configVariants = tmp11 === void 0 ? [] : tmp11, tmp12 = product.attributes, configAttributes = tmp12 === void 0 ? [] : tmp12;
    var clientSideProduct = (configVariants === null || configVariants === void 0 ? void 0 : configVariants.find(function(elem) {
        return elem.is_selected;
    })) || product;
    var productMinQty = !!!productMinQtyServer || !!!+productMinQtyServer ? 1 : productMinQtyServer;
    var ref8 = (0,react.useState)({}), filtered = ref8[0], setFiltered = ref8[1];
    var ref9 = (0,react.useState)(configAttributes), configAttributesCSR = ref9[0], setConfigAttributesCSR = ref9[1];
    var ref10 = (0,react.useState)(false), change = ref10[0], setChange = ref10[1];
    var ref11 = (0,react.useState)(productMinQty), quantity = ref11[0], setQuantity = ref11[1];
    var ref12 = (0,react.useState)(clientSideProduct), csrProductWithOpts = ref12[0], setCsrProductWithOpts = ref12[1];
    var ref13 = (0,react.useState)(/*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* HeartSvg */.xO, {})), wishIcon = ref13[0], setWishIcon = ref13[1];
    var wishlist = (0,es/* useSelector */.v9)(function(state) {
        return state.wishlist;
    });
    var isProductInWishList = wishlist === null || wishlist === void 0 ? void 0 : wishlist.find(function(item) {
        return item.id === productId;
    });
    (0,react.useEffect)(function() {
        var removalObject = null;
        if (configVariants.some(function(elem) {
            return elem.flats[0].status === 0 || elem.qty[0] === 0;
        })) {
            configVariants.forEach(function(variant) {
                if (variant.flats[0].status === 0 || variant.qty[0] === 0) {
                    var filterOnlyInt = variant.product_attribute_values.filter(function(prAttr) {
                        return prAttr.integer_value && configAttributes.some(function(iii) {
                            var ref;
                            return ((ref = iii === null || iii === void 0 ? void 0 : iii.attributes_values[0]) === null || ref === void 0 ? void 0 : ref.id) === (prAttr === null || prAttr === void 0 ? void 0 : prAttr.attribute_id);
                        });
                    });
                    if (filterOnlyInt.length === 1) {
                        if (removalObject === null || removalObject === void 0 ? void 0 : removalObject[filterOnlyInt[0].attribute_id]) {
                            removalObject = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, removalObject), (0,_define_property/* default */.Z)({}, filterOnlyInt[0].attribute_id, (0,_to_consumable_array/* default */.Z)(removalObject === null || removalObject === void 0 ? void 0 : removalObject[filterOnlyInt[0].attribute_id]).concat([
                                filterOnlyInt[0].integer_value
                            ])));
                        } else {
                            var ref;
                            removalObject = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, removalObject), (0,_define_property/* default */.Z)({}, (ref = filterOnlyInt[0]) === null || ref === void 0 ? void 0 : ref.attribute_id, [
                                filterOnlyInt[0].integer_value
                            ]));
                        }
                    }
                    if (removalObject) {
                        setConfigAttributesCSR(function() {
                            return configAttributes.map(function(confAttr) {
                                var ref, ref1;
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, confAttr), {
                                    attribute_options: confAttr === null || confAttr === void 0 ? void 0 : (ref = confAttr.attribute_options) === null || ref === void 0 ? void 0 : ref.map(function(attrOption) {
                                        var ref, ref1, ref2;
                                        if (removalObject === null || removalObject === void 0 ? void 0 : (ref2 = removalObject[confAttr === null || confAttr === void 0 ? void 0 : (ref = confAttr.attributes_values) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.id]) === null || ref2 === void 0 ? void 0 : ref2.every(function(iii) {
                                            return String(iii) !== String(attrOption.id);
                                        })) {
                                            return attrOption;
                                        } else {
                                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attrOption), {
                                                disabled: true
                                            });
                                        }
                                    }),
                                    attributes_values: [
                                        (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, confAttr === null || confAttr === void 0 ? void 0 : confAttr.attributes_values[0]), {
                                            attribute_options: (ref1 = confAttr === null || confAttr === void 0 ? void 0 : confAttr.attributes_values[0]) === null || ref1 === void 0 ? void 0 : ref1.attribute_options.map(function(attrOption) {
                                                var ref, ref1, ref2;
                                                if (removalObject === null || removalObject === void 0 ? void 0 : (ref2 = removalObject[confAttr === null || confAttr === void 0 ? void 0 : (ref = confAttr.attributes_values) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.id]) === null || ref2 === void 0 ? void 0 : ref2.every(function(iii) {
                                                    return String(iii) !== String(attrOption.id);
                                                })) {
                                                    return attrOption;
                                                } else {
                                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attrOption), {
                                                        disabled: true
                                                    });
                                                }
                                            })
                                        })
                                    ]
                                });
                            });
                        });
                    } else {
                        setConfigAttributesCSR(configAttributes);
                    }
                }
            });
        } else {
            setConfigAttributesCSR(configAttributes);
        }
    }, [
        productId
    ]);
    var _flats = (0,_sliced_to_array/* default */.Z)(clientSideProduct.flats, 1), ref14 = _flats[0], tmp13 = ref14.name, clientProductName = tmp13 === void 0 ? "" : tmp13, tmp14 = ref14.short_description, clientProductShortDesc = tmp14 === void 0 ? "" : tmp14, tmp15 = ref14.description, clientProductDesc = tmp15 === void 0 ? "" : tmp15, tmp16 = ref14.min_price, productMinPrice = tmp16 === void 0 ? null : tmp16, tmp17 = ref14.special_price, productSpecialPrice = tmp17 === void 0 ? null : tmp17, tmp18 = ref14.price, productPrice = tmp18 === void 0 ? null : tmp18, tmp19 = clientSideProduct.sku_option, ref15 = tmp19 === void 0 ? {} : tmp19, tmp20 = ref15.name, clientProductSkuOptionName = tmp20 === void 0 ? "SKU" : tmp20, tmp21 = clientSideProduct.sku, clientProductSku = tmp21 === void 0 ? "" : tmp21, tmp22 = clientSideProduct.short_description_option, ref16 = tmp22 === void 0 ? {} : tmp22, tmp23 = ref16.name, clientProductShortDescOptionName = tmp23 === void 0 ? "" : tmp23, tmp24 = clientSideProduct.description_option, ref17 = tmp24 === void 0 ? {} : tmp24, tmp25 = ref17.name, clientProductDescOptionName = tmp25 === void 0 ? "" : tmp25, tmp26 = clientSideProduct.details, clientProductDetails = tmp26 === void 0 ? [] : tmp26, _product_options = clientSideProduct.product_options, product_options = _product_options === void 0 ? [] : _product_options, tmp27 = clientSideProduct.is_selected, variantProductIsSelected = tmp27 === void 0 ? false : tmp27;
    (0,react.useEffect)(function() {
        setWishIcon(!!isProductInWishList ? /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* HeartActive */.wL, {
            className: (customInnerPage_module_default())["inner-wishlist"]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* HeartSvg */.xO, {}));
    }, [
        isProductInWishList
    ]);
    var ref18 = (0,react.useState)(!!clientProductDesc), isSelectDetail = ref18[0], setIsSelectDetail = ref18[1];
    var cartToken = (0,es/* useSelector */.v9)(function(state) {
        return state.cartToken;
    });
    var optionValues = (0,es/* useSelector */.v9)(function(state) {
        return state.product.optionValues;
    });
    var ref19 = (0,es/* useSelector */.v9)(function(state) {
        return state.customer;
    }), customerToken = ref19.token;
    var signed = (0,es/* useSelector */.v9)(function(state) {
        return state.customer.authenticated;
    });
    var dispatch = (0,es/* useDispatch */.I0)();
    var toast = (0,useToast/* useToast */.p)();
    var ref20 = (0,next_router.useRouter)(), asPath = ref20.asPath, routerPush = ref20.push;
    var rootRef = (0,react.useRef)(null);
    var isProductInStock = clientSideProduct.qty[0] > 0 || !!parseFloat(backOrderValue);
    var schema = schemaProduct(asPath, productName, productDesc, productImgPath, productSku, productId, dbName, domain, schemaBrandName);
    var addToast = function(error) {
        if (error) {
            toast.open(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "d-flex chek-fms",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* FailSvg */.as, {}),
                    translationsData.ProductNotAvailable
                ]
            }));
        } else {
            if (isProductInStock) {
                toast.open(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "d-flex chek-fms",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* CheckToastSvg */.xQ, {}),
                        translationsData.ToastAddToCart
                    ]
                }));
            }
        }
    };
    var seperatedAttrs = configVariants.map(function(param) {
        var product_attribute_values = param.product_attribute_values;
        return product_attribute_values.filter(function(prAttr) {
            return prAttr.integer_value;
        });
    }).flat().reduce(function(acc, curr) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, curr.product_id, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc[curr.product_id]), (0,_define_property/* default */.Z)({}, curr.attribute_id, curr.integer_value))));
    }, {});
    (0,react.useEffect)(function() {
        var data = configVariants === null || configVariants === void 0 ? void 0 : configVariants.filter(function(param) {
            var product_attribute_values = param.product_attribute_values;
            var ref = (product_attribute_values === null || product_attribute_values === void 0 ? void 0 : product_attribute_values.filter(function(param) {
                var integer_value = param.integer_value, attribute_id = param.attribute_id;
                if (!integer_value) return false;
                return String(filtered[attribute_id]) === String(integer_value);
            })) || [], tmp = ref.length, filteredLength = tmp === void 0 ? 0 : tmp;
            if (filteredLength > 0) {
                var ref1 = Object.values(filtered), tmp1 = ref1.length, filteredValuesLength = tmp1 === void 0 ? 0 : tmp1;
                return filteredLength === filteredValuesLength;
            }
            return false;
        });
        if (data.length === 1 && (Object.keys(filtered).length > 0 || configVariants.length !== 1) && !!Object.values(filtered).length) {
            routerPush("/".concat(data[0].flats[0].url_key));
        } else if (data.length === configVariants.length) {
            routerPush("/".concat(product.flats[0].url_key));
        }
        setIsSelectDetail(!clientProductDesc);
    }, [
        change,
        clientProductDesc
    ]);
    var handleChangeConfig = function(param) {
        var attribute_id = param.attribute_id, id = param.id;
        var updatedFiltered = (0,_object_spread/* default */.Z)({}, filtered);
        var updateStateHandle = {
            "true": function() {
                return delete updatedFiltered[attribute_id];
            },
            "false": function() {
                return updatedFiltered[attribute_id] = id;
            }
        };
        updateStateHandle["".concat(String(updatedFiltered[attribute_id] === String(id)))]();
        configInActiveVariantHelper({
            configVariants: configVariants,
            updatedFiltered: updatedFiltered,
            setConfigAttributesCSR: setConfigAttributesCSR,
            configAttributes: configAttributes,
            configAttributesCSR: configAttributesCSR
        });
        configNotExistVariantHelper({
            configAttributesCSR: configAttributesCSR,
            filtered: updatedFiltered,
            setConfigAttributesCSR: setConfigAttributesCSR,
            seperatedAttrs: seperatedAttrs,
            variantProductIsSelected: variantProductIsSelected
        });
        setFiltered(updatedFiltered);
        setChange(function(prevChange) {
            return !prevChange;
        });
    };
    (0,react.useEffect)(function() {
        var selectedVariant = configVariants === null || configVariants === void 0 ? void 0 : configVariants.find(function(elem) {
            return elem.is_selected;
        });
        if (selectedVariant) {
            var ref;
            var attrValues = (selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.product_attribute_values) === null || ref === void 0 ? void 0 : ref.filter(function(param) {
                var integer_value = param.integer_value;
                return integer_value;
            })) || [];
            //TODO!!! this part written for more strict matching of attributes and their values, but i dont want at start wrote too complicated logic, so i commented it, after test if we would need it i will uncomment it
            var x = configAttributes.map(function(elem) {
                var ref, ref1, ref2, ref3;
                return (0,_define_property/* default */.Z)({}, elem === null || elem === void 0 ? void 0 : (ref = elem.attributes_values) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.id, elem === null || elem === void 0 ? void 0 : (ref2 = elem.attributes_values) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.attribute_options.map(function(e) {
                    return e.id;
                }));
            });
            var insideFiltered = {};
            attrValues === null || attrValues === void 0 ? void 0 : attrValues.forEach(function(param) {
                var attribute_id = param.attribute_id, integer_value = param.integer_value;
                var hasThisKey = x.find(function(elem) {
                    return Object.keys(elem)[0] === String(attribute_id);
                });
                if (hasThisKey) {
                    if (x.some(function(elem) {
                        return Object.keys(elem)[0] === String(attribute_id) && elem[attribute_id].includes(Number(integer_value));
                    })) {
                        insideFiltered = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, insideFiltered), (0,_define_property/* default */.Z)({}, attribute_id, Number(integer_value)));
                        setFiltered(function(prevState) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), (0,_define_property/* default */.Z)({}, attribute_id, Number(integer_value)));
                        });
                    }
                }
            });
            //TODO!!! this part for simple matching of attributes and their values
            // let insideFiltered: Record<string, number> = {};
            // attrValues?.forEach(({attribute_id, integer_value}: { attribute_id: number, integer_value: string }) => {
            //     insideFiltered = {
            //         ...insideFiltered,
            //         [attribute_id]: Number(integer_value)
            //     }
            //     setFiltered((prevState) => ({
            //         ...prevState,
            //         [attribute_id]: Number(integer_value)
            //     }))
            // })
            configInActiveVariantHelper({
                configVariants: configVariants,
                updatedFiltered: insideFiltered,
                setConfigAttributesCSR: setConfigAttributesCSR,
                configAttributes: configAttributes,
                configAttributesCSR: configAttributesCSR
            });
            configNotExistVariantHelper({
                configAttributesCSR: configAttributesCSR,
                filtered: insideFiltered,
                setConfigAttributesCSR: setConfigAttributesCSR,
                seperatedAttrs: seperatedAttrs,
                variantProductIsSelected: variantProductIsSelected
            });
        }
    }, []);
    var calculateMaxQty = function() {
        var ref, ref1, ref2;
        var filteredDataLengthToggle = function() {
            var ref = (configVariants === null || configVariants === void 0 ? void 0 : configVariants.find(function(param) {
                var _qty = (0,_sliced_to_array/* default */.Z)(param.qty, 1), dataElemQty = _qty[0];
                return dataElemQty > 0;
            })) || {}, tmp = ref.qty, ref1 = (0,_sliced_to_array/* default */.Z)(tmp === void 0 ? [] : tmp, 1), tmp1 = ref1[0], maxVariantQuantity = tmp1 === void 0 ? 0 : tmp1;
            return maxVariantQuantity;
        };
        var maxQtyHandle = {
            "true": {
                "true": (ref = configVariants[0]) === null || ref === void 0 ? void 0 : ref.maxQty,
                "false": (ref1 = configVariants[0]) === null || ref1 === void 0 ? void 0 : ref1.maxQty
            },
            "false": {
                "true": filteredDataLengthToggle(),
                "false": 0
            }
        };
        return maxQtyHandle["".concat(!!(product === null || product === void 0 ? void 0 : (ref2 = product.additional) === null || ref2 === void 0 ? void 0 : ref2.default_variant_id))]["".concat(Object.keys(filtered).length > 0)];
    };
    var ref21 = useCustomOptions({
        setClientSideProduct: setCsrProductWithOpts,
        product: clientSideProduct,
        productMinPrice: productMinPrice,
        productSpecialPrice: productSpecialPrice,
        productPrice: productPrice,
        selectedRate: selectedRate,
        asPath: asPath,
        productSlug: productSlug
    }), customOptions = ref21.customOptions, refsMap = ref21.refsMap;
    (0,react.useEffect)(function() {
        setCsrProductWithOpts(clientSideProduct);
        dispatch((0,store_product/* setOptionValuesAction */.vD)({
            isConfig: true,
            id: 0,
            label: "",
            price: "",
            optionId: 0
        }));
    }, [
        productSlug,
        clientProductSku
    ]);
    useFetchCartToken(cartToken);
    var selectTab = function(e) {
        setIsSelectDetail(e.target.id === "detail");
    };
    var priceHtmlAvailable = {
        "true": (ref = clientSideProduct === null || clientSideProduct === void 0 ? void 0 : clientSideProduct.flats[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.price_html) === null || ref1 === void 0 ? void 0 : ref1.map(function(e, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (customInnerPage_module_default()).product_price_html,
                children: e
            }, i);
        }),
        "false": /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
    };
    var handleWishIconClick = function(e) {
        e.preventDefault();
        if (!signed) {
            toast.open(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "d-flex faild-toast-fms",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* FailSvg */.as, {}),
                    translationsData.ToastSignIn
                ]
            }));
        } else {
            !!isProductInWishList ? dispatch((0,wishlistActions/* wishlistRemoveItem */.uv)(product.id)) : dispatch((0,wishlistActions/* wishlistAddItem */.c8)(product, selectedLocale));
            var toastChildren = {
                "true": {
                    svg: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* FailSvg */.as, {}),
                    title: translationsData === null || translationsData === void 0 ? void 0 : translationsData.ToastWishListRemove
                },
                "false": {
                    svg: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* CheckToastSvg */.xQ, {}),
                    title: translationsData === null || translationsData === void 0 ? void 0 : translationsData.ToastWishList
                }
            };
            toast.open(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "d-flex faild-toast-fms",
                children: [
                    toastChildren["".concat(!!isProductInWishList)].svg,
                    toastChildren["".concat(!!isProductInWishList)].title
                ]
            }));
        }
    };
    var descriptions = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "product-inner-long-description",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                paddingLeft: "30px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: clientProductDesc
                }
            })
        })
    });
    var details = /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerPageProduct_CustomDetails, {
        details: clientProductDetails,
        isSelectDetail: isSelectDetail,
        showDetailsInFront: showDetailsInFront,
        translationsData: translationsData,
        dbName: dbName,
        domain: domain
    });
    var handleAddCartClickLocal = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var quantity, ref, filterRequiredOptions, everyItemExist, addCartFunc, ref1, _resStatus, resStatus;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        quantity = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : 1;
                        if ((product_options === null || product_options === void 0 ? void 0 : product_options.length) > 0) {
                            filterRequiredOptions = product_options.filter(function(option) {
                                return Number(option === null || option === void 0 ? void 0 : option.required);
                            });
                            if (filterRequiredOptions === null || filterRequiredOptions === void 0 ? void 0 : filterRequiredOptions.length) {
                                everyItemExist = filterRequiredOptions === null || filterRequiredOptions === void 0 ? void 0 : filterRequiredOptions.filter(function(item) {
                                    return !optionValues.some(function(option) {
                                        return option.id === item.id;
                                    });
                                }).map(function(item) {
                                    return item.id;
                                });
                                if (everyItemExist.length > 0) {
                                    dispatch((0,store_product/* setNotFilledOptionsAction */.WM)(everyItemExist));
                                    return [
                                        2
                                    ];
                                }
                            }
                        }
                        dispatch((0,store_product/* setNotFilledOptionsAction */.WM)([]));
                        addCartFunc = function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                (0,helpers/* handleAddCard */.x)({
                                                    openUpCrossProd: function() {
                                                        return (0,helpers/* openUpCrossProd */.Vr)({
                                                            dispatch: dispatch,
                                                            productId: productId,
                                                            selectedLocale: selectedLocale,
                                                            selectedRate: selectedRate,
                                                            product: clientSideProduct
                                                        });
                                                    },
                                                    dispatch: dispatch,
                                                    data: {
                                                        product: clientSideProduct,
                                                        quantity: quantity,
                                                        cartToken: cartToken,
                                                        customer: {
                                                            token: customerToken
                                                        },
                                                        selectedLocale: selectedLocale,
                                                        selectedCurrCode: selectedRate.code,
                                                        optionsObject: Object.keys(customOptions === null || customOptions === void 0 ? void 0 : customOptions.customizable_options).length > 0 ? customOptions : null,
                                                        addToast: addToast
                                                    },
                                                    routerPush: routerPush,
                                                    isProductInStock: isProductInStock
                                                })
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                _state.sent()
                                            ];
                                    }
                                });
                            });
                            return function addCartFunc() {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        if (!((product === null || product === void 0 ? void 0 : (ref = product.attribute_family) === null || ref === void 0 ? void 0 : ref.code) === "Donation")) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            addCartFunc()
                        ];
                    case 1:
                        ref1 = _state.sent() || {}, _resStatus = ref1.resStatus, resStatus = _resStatus === void 0 ? 200 : _resStatus;
                        if (!(resStatus === 200)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            routerPush("/checkout")
                        ];
                    case 2:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 3:
                        return [
                            3,
                            6
                        ];
                    case 4:
                        return [
                            4,
                            addCartFunc()
                        ];
                    case 5:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleAddCartClickLocal() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: schema.name,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(schema)
                },
                defer: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (customInnerPage_module_default()).product__content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomProductGallery/* default */.Z, {
                                images: clientSideProduct.images,
                                dbName: dbName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (customInnerPage_module_default()).product__info,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerPageProduct_CustomInfoPart, {
                                        product: clientSideProduct,
                                        productName: clientProductName,
                                        productSkuOptionName: clientProductSkuOptionName,
                                        productSku: clientProductSku,
                                        selectedCurrSymbol: selectedRate === null || selectedRate === void 0 ? void 0 : selectedRate.symbol,
                                        selectedCurrCode: selectedRate === null || selectedRate === void 0 ? void 0 : selectedRate.code,
                                        clientSidePrice: {
                                            price: (optionValues === null || optionValues === void 0 ? void 0 : optionValues.length) > 0 ? csrProductWithOpts === null || csrProductWithOpts === void 0 ? void 0 : csrProductWithOpts.flats[0].price : clientSideProduct.flats[0].price,
                                            specialPrice: (optionValues === null || optionValues === void 0 ? void 0 : optionValues.length) > 0 ? (ref2 = csrProductWithOpts === null || csrProductWithOpts === void 0 ? void 0 : csrProductWithOpts.flats[0]) === null || ref2 === void 0 ? void 0 : ref2.special_price : (ref3 = clientSideProduct.flats[0]) === null || ref3 === void 0 ? void 0 : ref3.special_price,
                                            cost: (optionValues === null || optionValues === void 0 ? void 0 : optionValues.length) > 0 ? csrProductWithOpts === null || csrProductWithOpts === void 0 ? void 0 : csrProductWithOpts.flats[0].cost : clientSideProduct.flats[0].cost
                                        },
                                        priceHtmlAvailable: priceHtmlAvailable["".concat(!!productPriceHtml)],
                                        productShortDescOptionName: clientProductShortDescOptionName,
                                        productShortDesc: clientProductShortDesc,
                                        productOptions: product_options,
                                        translationsData: translationsData,
                                        refsMap: refsMap,
                                        sizeChart: sizeChart,
                                        dbName: dbName,
                                        domain: domain,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerPageProduct_CustomConfigurableFilters, {
                                            handleChangeConfig: handleChangeConfig,
                                            configurableData: configAttributesCSR,
                                            filtered: filtered
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: (customInnerPage_module_default()).product__meta,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: (customInnerPage_module_default())["product__meta-availability"],
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: dangerOrSuccessStyleConfig["".concat(isProductInStock)]["".concat(clientSideProduct.type === "configurable")].className,
                                                    style: {
                                                        fontSize: "18px"
                                                    },
                                                    children: translationsData === null || translationsData === void 0 ? void 0 : translationsData[dangerOrSuccessStyleConfig["".concat(isProductInStock)]["".concat(clientSideProduct.type === "configurable")].IntlKey]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((customInnerPage_module_default())["product__actions-item"], " ").concat((customInnerPage_module_default())["product-inner-quantity"]),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputNumber/* default */.Z, {
                                                    id: "product-quantity",
                                                    "aria-label": "Quantity",
                                                    className: (customInnerPage_module_default()).product__quantity,
                                                    size: "lg",
                                                    min: productMinQty,
                                                    max: calculateMaxQty(),
                                                    value: quantity,
                                                    onChange: function(quantity) {
                                                        if (quantity > calculateMaxQty()) {
                                                            setQuantity(calculateMaxQty());
                                                        } else {
                                                            setQuantity(quantity);
                                                        }
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (customInnerPage_module_default()).sidebar__details,
                                        children: !showDetailsInFront && !!productDetails.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerPageProduct_CustomDetails, {
                                            details: productDetails,
                                            isSelectDetail: isSelectDetail,
                                            showDetailsInFront: true,
                                            translationsData: translationsData,
                                            dbName: dbName,
                                            domain: domain
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerPageProduct_CustomSideBar, {
                                        ProductAddToCart_INTL: translationsData === null || translationsData === void 0 ? void 0 : translationsData.AddToCartButtonTitle,
                                        actionClassName: addCartDivStyleToggleConfig["".concat(isProductInStock)]["".concat(clientSideProduct.parent_id || (clientSideProduct === null || clientSideProduct === void 0 ? void 0 : clientSideProduct.length) === 0)],
                                        handleCardClick: handleAddCartClickLocal,
                                        isButtonDisabled: !(calculateMaxQty() > 0) || !+backOrderValue && clientSideProduct.qty[0] === 0,
                                        wishListButtonClick: handleWishIconClick,
                                        wishIconClicked: wishIcon,
                                        minimalQty: productMinQty,
                                        maximalQty: calculateMaxQty(),
                                        inpValQuantity: quantity,
                                        setQuantity: setQuantity,
                                        requestFormDetails: requestFormDetails,
                                        requestFormInfo: requestFormInfo
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerPageProduct_CustomSocialLinks, {
                                        dbName: dbName,
                                        domain: domain,
                                        productSlug: productSlug
                                    })
                                ]
                            })
                        ]
                    }),
                    showBuilderComponents(2)["".concat(showBuilderData)],
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerPageProduct_CustomDetailTabButtons, {
                        boxAboutDetailsClass: showBoxAboutDetails["".concat(showDetailsInFront)],
                        isSelectedDetailSectionClass: isSelectedDetailSectionClass(descriptions, details)["".concat(isSelectDetail)],
                        productDescOptionName: clientProductDescOptionName,
                        Details_INTL: translationsData === null || translationsData === void 0 ? void 0 : translationsData.Details,
                        selectTab: selectTab,
                        showDescription: !!clientProductDesc,
                        showDetailsInFront: showDetailsInFront
                    }),
                    isSelectedDetailSectionClass(descriptions, details)["".concat(isSelectDetail)].content
                ]
            })
        ]
    });
};
/* harmony default export */ var InnerPageProduct_CustomConfig = (CustomConfig); //TODO!!! stay with this if the handler not help setted on click
 // useEffect(() => {
 //     const filteredVal = Object.entries(lll).filter((elem) => {
 //         return Object.entries(filtered).every((asd) => {
 //             return String(elem[1][asd[0]]) === String(asd[1])
 //         })
 //     })
 //     const removalObject = Object.values(Object.assign(Object.fromEntries(filteredVal)));
 //     setConfigAttributesCSR((prevState) => {
 //         return prevState.map((confAttr) => {
 //             return {
 //                 ...confAttr,
 //                 attribute_options: confAttr?.attribute_options?.map((attrOption) => {
 //                     const findII = removalObject.some((elem) => {
 //                         const uuu = Object.entries(filtered).some((ifff, _, array) => {
 //                             const filteredArr = array.filter(asd => String(asd[0]) !== String(ifff[0]));
 //                             const x123123123 = Object.values(lll).filter((elem) => {
 //                                 return filteredArr.every((asd) => {
 //                                     return String(elem[asd[0]]) === String(asd[1])
 //                                 })
 //                             }).map(oji => {
 //                                 const uppOji = Object.entries(oji).filter(asd => {
 //                                     return !filteredArr.some(asdasd => asdasd[0] === asd[0])
 //                                 })
 //                                 return Object.fromEntries(uppOji)
 //                             })
 //                             return x123123123.some((elemelem) => String(elemelem[attrOption.attribute_id]) === String(attrOption.id))
 //                         })
 //                         if (Object.values(filtered).length === configAttributesCSR.length || variantProductIsSelected) {
 //                             return uuu
 //                         }
 //                         if (
 //                             filtered.hasOwnProperty(attrOption.attribute_id)
 //                             && Object.values(filtered).length !== configAttributesCSR.length - 1
 //                         ) {
 //                             return true
 //                         }
 //                         return String(elem[attrOption.attribute_id]) === String(attrOption.id)
 //                     })
 //                     if (findII) {
 //                         return {...attrOption, disabled: false}
 //                     } else {
 //                         return {...attrOption, disabled: true}
 //                     }
 //                 }),
 //                 attributes_values: [{
 //                     ...confAttr?.attributes_values[0],
 //                     attribute_options: confAttr?.attributes_values[0]?.attribute_options.map((attrOption) => {
 //                         const findII = removalObject.some((elem) => {
 //                             const uuu = Object.entries(filtered).some((ifff, _, array) => {
 //                                 const filteredArr = array.filter(asd => String(asd[0]) !== String(ifff[0]));
 //                                 const x123123123 = Object.values(lll).filter((elem) => {
 //                                     return filteredArr.every((asd) => {
 //                                         return String(elem[asd[0]]) === String(asd[1])
 //                                     })
 //                                 }).map(oji => {
 //                                     const uppOji = Object.entries(oji).filter(asd => {
 //                                         return !filteredArr.some(asdasd => asdasd[0] === asd[0])
 //                                     })
 //                                     return Object.fromEntries(uppOji)
 //                                 })
 //                                 return x123123123.some((elemelem) => String(elemelem[attrOption.attribute_id]) === String(attrOption.id))
 //                             })
 //                             if (Object.values(filtered).length === configAttributesCSR.length || variantProductIsSelected) {
 //                                 return uuu
 //                             }
 //                             if (
 //                                 filtered.hasOwnProperty(attrOption.attribute_id)
 //                                 && Object.values(filtered).length !== configAttributesCSR.length - 1
 //                             ) {
 //                                 return true
 //                             }
 //                             return String(elem[attrOption.attribute_id]) === String(attrOption.id)
 //                         })
 //                         if (findII) {
 //                             return {...attrOption, disabled: false}
 //                         } else {
 //                             return {...attrOption, disabled: true}
 //                         }
 //                     })
 //                 }]
 //             }
 //         })
 //     })
 // }, [filtered]);

;// CONCATENATED MODULE: ./components/ForCWV/InnerPageProduct/CustomDownloadableSideBar.tsx











var CustomDownloadableSideBar = function(param) {
    var ProductAddToCart_INTL = param.ProductAddToCart_INTL, actionClassName = param.actionClassName, handleCardClick = param.handleCardClick, isButtonDisabled = param.isButtonDisabled, wishListButtonClick = param.wishListButtonClick, wishIconClicked = param.wishIconClicked, product = param.product, dbName = param.dbName, setCheckedLinks = param.setCheckedLinks, checkedLinks = param.checkedLinks, selectedCurrSymbol = param.selectedCurrSymbol, selectedCurrCode = param.selectedCurrCode, translationsData = param.translationsData, requestFormDetails = param.requestFormDetails, requestFormInfo = param.requestFormInfo;
    var dispatch = (0,es/* useDispatch */.I0)();
    var Button = function(param) {
        var _className = param.className, className = _className === void 0 ? "" : _className, _title = param.title, title = _title === void 0 ? ProductAddToCart_INTL : _title, _onClick = param.onClick, onClick = _onClick === void 0 ? function() {
            if (checkedLinks.length > 0) {
                handleCardClick();
                setRequired(false);
            } else {
                setRequired(true);
            }
        } : _onClick, _isButtonDisabledInside = param.isButtonDisabledInside, isButtonDisabledInside = _isButtonDisabledInside === void 0 ? false : _isButtonDisabledInside;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((customInnerPage_module_default())["product__actions-item"], " ").concat((customInnerPage_module_default())["product__actions-item--addToCart"]),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((customInnerPage_module_default())["product__actions-item"], " ").concat((customInnerPage_module_default())["product__actions-item--addToCart"], " ").concat(actionClassName),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        e.preventDefault();
                                        return [
                                            4,
                                            onClick()
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(e) {
                            return _ref.apply(this, arguments);
                        };
                    }(),
                    disabled: isButtonDisabledInside,
                    className: "btn btn-orange ".concat((customInnerPage_module_default())["inner-addToCart"], " ").concat((customInnerPage_module_default())["rounded-pills"], " btn-lg ").concat(className),
                    children: title
                })
            })
        });
    };
    var ref = (0,react.useState)(false), required = ref[0], setRequired = ref[1];
    var validationMessage = {
        "true": /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            className: (customInnerPage_module_default()).required__text,
            children: translationsData.LinksRequired
        }),
        "false": null
    };
    var sampleLinks = {
        "true": /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (customInnerPage_module_default()).links__heading,
                    children: translationsData.Samples
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (customInnerPage_module_default()).product__samples,
                    children: product.downloadable_samples.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (customInnerPage_module_default()).sample__link,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/api/downloadable/download-sample/sample/").concat(item.id)),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (customInnerPage_module_default()).sample__links__items,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* DownloadCloudIcon */.ND, {}),
                                        item.title
                                    ]
                                })
                            })
                        }, index);
                    })
                })
            ]
        }),
        "false": null
    };
    var productLinks = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (customInnerPage_module_default()).product__links,
        children: product.downloadable_links.map(function(_param, index) {
            var id = _param.id, item = (0,_object_without_properties/* default */.Z)(_param, [
                "id"
            ]);
            var isSamples = item.sample_url || item.sample_file_url !== null;
            var positionSymbolHandle = function() {
                if (selectedCurrCode === "AMD") {
                    return "".concat(item.price).concat(selectedCurrSymbol);
                }
                return "".concat(selectedCurrSymbol).concat(item.price);
            };
            var price = {
                "true": "+ ".concat(positionSymbolHandle()),
                "false": null
            };
            var handleCheckLinksChane = function() {
                setCheckedLinks(function(prevState) {
                    var updatedStateArray = (0,_to_consumable_array/* default */.Z)(prevState);
                    var findElem = updatedStateArray.some(function(param) {
                        var someId = param.id;
                        return id === someId;
                    });
                    if (findElem) {
                        return updatedStateArray.filter(function(param) {
                            var filterId = param.id;
                            return filterId !== id;
                        });
                    } else {
                        updatedStateArray.push({
                            id: id
                        });
                    }
                    setRequired(updatedStateArray.length === 0);
                    return updatedStateArray;
                });
            };
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (customInnerPage_module_default()).product__variant,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (customInnerPage_module_default()).variant__link,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "checkbox",
                                    onChange: handleCheckLinksChane
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (customInnerPage_module_default()).variant__sample,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            item.title,
                                            " ",
                                            price["".concat(item.price > 0)]
                                        ]
                                    })
                                })
                            ]
                        }),
                        isSamples ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            href: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/api/downloadable/download-sample/link/").concat(id)),
                            className: (customInnerPage_module_default()).links__sample__items,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* DownloadCloudIcon */.ND, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: translationsData.Sample
                                })
                            ]
                        }) : null
                    ]
                })
            }, index);
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (customInnerPage_module_default()).product__sidebar,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
            className: (customInnerPage_module_default()).product__options,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "form-group ".concat((customInnerPage_module_default()).product__option),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (customInnerPage_module_default()).downloadable__links,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (customInnerPage_module_default()).product__samples_container,
                                children: sampleLinks["".concat(product.downloadable_samples.length > 0)]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (customInnerPage_module_default()).product__links_container,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (customInnerPage_module_default()).links__heading,
                                        children: translationsData.Links
                                    }),
                                    productLinks,
                                    validationMessage["".concat(required)]
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (customInnerPage_module_default()).product__actions,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (customInnerPage_module_default())["inner-buttons-wrapper"],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                                        isButtonDisabledInside: isButtonDisabled
                                    }),
                                    Number(requestFormDetails === null || requestFormDetails === void 0 ? void 0 : requestFormDetails.requestFormActive) && (requestFormDetails === null || requestFormDetails === void 0 ? void 0 : requestFormDetails.requestFormBtn) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                                        isButtonDisabledInside: false,
                                        className: "inner-request-form-button",
                                        title: requestFormDetails === null || requestFormDetails === void 0 ? void 0 : requestFormDetails.requestFormBtn,
                                        onClick: function() {
                                            var ref;
                                            return dispatch((0,formbuilder/* setFormPopupOpen */.YK)({
                                                id: requestFormInfo === null || requestFormInfo === void 0 ? void 0 : (ref = requestFormInfo.data) === null || ref === void 0 ? void 0 : ref.id,
                                                open: true
                                            }));
                                        }
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((customInnerPage_module_default())["product__actions-item"], " ").concat((customInnerPage_module_default())["product__actions-item--wishlist"], " ").concat((customInnerPage_module_default())["liked-button-wrapper"]),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        "aria-label": "Wish list",
                                        title: "Wishlist",
                                        onClick: wishListButtonClick,
                                        className: "btn-light btn-svg-icon btn-svg-icon--fake-svg",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (customInnerPage_module_default())["wishlist-icon-wrapper"],
                                            children: wishIconClicked
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var InnerPageProduct_CustomDownloadableSideBar = (CustomDownloadableSideBar);

;// CONCATENATED MODULE: ./components/ForCWV/InnerPageProduct/CustomDownloadableProduct.tsx

















var CustomDownloadableProduct = function(param) {
    var dbName = param.dbName, productSlug = param.productSlug, domain = param.domain, selectedRate = param.selectedRate, product = param.product, backOrderValue = param.backOrderValue, translationsData = param.translationsData, selectedLocale = param.selectedLocale, schemaBrandName = param.schemaBrandName, showDetailsInFront = param.showDetailsInFront, showBuilderComponents = param.showBuilderComponents, showBuilderData = param.showBuilderData, requestFormInfo = param.requestFormInfo, requestFormDetails = param.requestFormDetails, sizeChart = param.sizeChart;
    var ref, ref1;
    var ref2 = (0,react.useState)([]), checkedLinks = ref2[0], setCheckedLinks = ref2[1];
    var ref3 = (0,react.useState)(product), clientSideProduct = ref3[0], setClientSideProduct = ref3[1];
    (0,react.useEffect)(function() {
        setClientSideProduct(product);
    }, [
        productSlug,
        selectedLocale
    ]);
    var tmp = clientSideProduct.flats, ref4 = (0,_sliced_to_array/* default */.Z)(tmp === void 0 ? [] : tmp, 1), tmp1 = ref4[0], ref5 = tmp1 === void 0 ? {} : tmp1, tmp2 = ref5.name, productName = tmp2 === void 0 ? "" : tmp2, tmp3 = ref5.description, productDesc = tmp3 === void 0 ? "" : tmp3, tmp4 = ref5.min_price, productMinPrice = tmp4 === void 0 ? null : tmp4, tmp5 = ref5.special_price, productSpecialPrice = tmp5 === void 0 ? null : tmp5, tmp6 = ref5.short_description, productShortDesc = tmp6 === void 0 ? "" : tmp6, tmp7 = ref5.price, productPrice = tmp7 === void 0 ? null : tmp7, tmp8 = ref5.price_html, productPriceHtml = tmp8 === void 0 ? null : tmp8, _has_up_sell = ref5.has_up_sell, has_up_sell = _has_up_sell === void 0 ? 0 : _has_up_sell, _has_cross_sell = ref5.has_cross_sell, has_cross_sell = _has_cross_sell === void 0 ? 0 : _has_cross_sell, tmp9 = clientSideProduct.images, ref6 = (0,_sliced_to_array/* default */.Z)(tmp9 === void 0 ? [] : tmp9, 1), tmp10 = ref6[0], productImgPath = tmp10 === void 0 ? "" : tmp10, productId = clientSideProduct.id, tmp11 = clientSideProduct.sku, productSku = tmp11 === void 0 ? "" : tmp11, tmp12 = clientSideProduct.details, productDetails = tmp12 === void 0 ? [] : tmp12, tmp13 = clientSideProduct.sku_option, ref7 = tmp13 === void 0 ? {} : tmp13, tmp14 = ref7.name, productSkuOptionName = tmp14 === void 0 ? "SKU" : tmp14, tmp15 = clientSideProduct.short_description_option, ref8 = tmp15 === void 0 ? {} : tmp15, tmp16 = ref8.name, productShortDescOptionName = tmp16 === void 0 ? "" : tmp16, tmp17 = clientSideProduct.description_option, ref9 = tmp17 === void 0 ? {} : tmp17, tmp18 = ref9.name, productDescOptionName = tmp18 === void 0 ? "" : tmp18, _product_options = clientSideProduct.product_options, product_options = _product_options === void 0 ? [] : _product_options, _qty = (0,_sliced_to_array/* default */.Z)(clientSideProduct.qty, 1), productInitialQty = _qty[0];
    var ref10 = (0,react.useState)(!productDesc), isSelectDetail = ref10[0], setIsSelectDetail = ref10[1];
    var cartToken = (0,es/* useSelector */.v9)(function(state) {
        return state.cartToken;
    });
    var ref11 = (0,es/* useSelector */.v9)(function(state) {
        return state.customer;
    }), customerToken = ref11.token;
    var signed = (0,es/* useSelector */.v9)(function(state) {
        return state.customer.authenticated;
    });
    var wishlist = (0,es/* useSelector */.v9)(function(state) {
        return state.wishlist;
    });
    var isProductInWishList = wishlist === null || wishlist === void 0 ? void 0 : wishlist.find(function(item) {
        return item.id === productId;
    });
    var ref12 = (0,react.useState)(/*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* HeartSvg */.xO, {})), wishIcon = ref12[0], setWishIcon = ref12[1];
    (0,react.useEffect)(function() {
        setWishIcon(!!isProductInWishList ? /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* HeartActive */.wL, {
            className: (customInnerPage_module_default())["inner-wishlist"]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* HeartSvg */.xO, {}));
    }, [
        isProductInWishList
    ]);
    var dispatch = (0,es/* useDispatch */.I0)();
    var toast = (0,useToast/* useToast */.p)();
    var asPath = (0,next_router.useRouter)().asPath;
    var toastOpenHandle = {
        "true": function() {
            return toast.open(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "d-flex chek-fms",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* FailSvg */.as, {}),
                    translationsData.ProductNotAvailable
                ]
            }));
        },
        "false": function() {
            return toast.open(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "d-flex chek-fms",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* CheckToastSvg */.xQ, {}),
                    translationsData.ToastAddToCart
                ]
            }));
        }
    };
    var addToast = function(error) {
        return toastOpenHandle["".concat(error)]();
    };
    var schema = schemaProduct(asPath, productName, productDesc, productImgPath, productSku, productId, dbName, domain, schemaBrandName);
    useFetchCartToken(cartToken);
    var selectTab = function(e) {
        setIsSelectDetail(e.target.id === "detail");
    };
    var handleWishIconClick = function(e) {
        e.preventDefault();
        if (!signed) {
            toast.open(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "d-flex faild-toast-fms",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* FailSvg */.as, {}),
                    translationsData.ToastSignIn
                ]
            }));
        } else {
            !!isProductInWishList ? dispatch((0,wishlistActions/* wishlistRemoveItem */.uv)(product.id)) : dispatch((0,wishlistActions/* wishlistAddItem */.c8)(product, selectedLocale));
            var toastChildren = {
                "true": {
                    svg: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* FailSvg */.as, {}),
                    title: translationsData === null || translationsData === void 0 ? void 0 : translationsData.ToastWishListRemove
                },
                "false": {
                    svg: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* CheckToastSvg */.xQ, {}),
                    title: translationsData === null || translationsData === void 0 ? void 0 : translationsData.ToastWishList
                }
            };
            toast.open(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "d-flex faild-toast-fms",
                children: [
                    toastChildren["".concat(!!isProductInWishList)].svg,
                    toastChildren["".concat(!!isProductInWishList)].title
                ]
            }));
        }
    };
    var priceHtmlAvailable = {
        "true": (ref = product === null || product === void 0 ? void 0 : product.flats[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.price_html) === null || ref1 === void 0 ? void 0 : ref1.map(function(e, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (customInnerPage_module_default()).product_price_html,
                children: e
            }, i);
        }),
        "false": /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
    };
    var isButtonDisabled = {
        "true": !!!+backOrderValue,
        "false": false
    };
    var descriptions = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (customInnerPage_module_default())["product-inner-long-description"],
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                paddingLeft: "30px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: productDesc
                }
            })
        })
    });
    var details = /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerPageProduct_CustomDetails, {
        details: productDetails,
        isSelectDetail: isSelectDetail,
        showDetailsInFront: showDetailsInFront,
        translationsData: translationsData,
        dbName: dbName,
        domain: domain
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: schema.name,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(schema)
                },
                defer: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    showBuilderComponents(1)["".concat(showBuilderData)],
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (customInnerPage_module_default()).product__content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomProductGallery/* default */.Z, {
                                images: product.images,
                                dbName: dbName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (customInnerPage_module_default()).product__info,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerPageProduct_CustomInfoPart, {
                                        product: clientSideProduct,
                                        productName: productName,
                                        productSkuOptionName: productSkuOptionName,
                                        productSku: productSku,
                                        selectedCurrSymbol: selectedRate === null || selectedRate === void 0 ? void 0 : selectedRate.symbol,
                                        selectedCurrCode: selectedRate === null || selectedRate === void 0 ? void 0 : selectedRate.code,
                                        clientSidePrice: {
                                            price: clientSideProduct.flats[0].price,
                                            specialPrice: clientSideProduct.flats[0].special_price || 0,
                                            cost: clientSideProduct.flats[0].cost
                                        },
                                        priceHtmlAvailable: priceHtmlAvailable["".concat(!!productPriceHtml)],
                                        productShortDescOptionName: productShortDescOptionName,
                                        productShortDesc: productShortDesc,
                                        productOptions: product_options,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {}),
                                        translationsData: translationsData,
                                        sizeChart: sizeChart,
                                        domain: domain,
                                        dbName: dbName
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerPageProduct_CustomDownloadableSideBar, {
                                        product: product,
                                        ProductAddToCart_INTL: translationsData === null || translationsData === void 0 ? void 0 : translationsData.AddToCartButtonTitle,
                                        actionClassName: addCartDivStyleToggleSimple["".concat(true)],
                                        handleCardClick: handleCardClick({
                                            dispatch: dispatch,
                                            productId: productId,
                                            selectedRate: selectedRate,
                                            has_up_sell: has_up_sell,
                                            has_cross_sell: has_cross_sell,
                                            addToast: addToast,
                                            selectedLocale: selectedLocale,
                                            cartToken: cartToken,
                                            customerToken: customerToken,
                                            product: product,
                                            quantity: 1,
                                            links: checkedLinks.map(function(param) {
                                                var id = param.id;
                                                return id;
                                            })
                                        })["".concat(true)]["".concat(!!parseFloat(has_up_sell))]["".concat(!!parseFloat(has_cross_sell))],
                                        isButtonDisabled: isButtonDisabled["".concat(productInitialQty === 0)],
                                        wishListButtonClick: handleWishIconClick,
                                        wishIconClicked: wishIcon,
                                        dbName: dbName,
                                        checkedLinks: checkedLinks,
                                        setCheckedLinks: setCheckedLinks,
                                        selectedCurrSymbol: selectedRate === null || selectedRate === void 0 ? void 0 : selectedRate.symbol,
                                        selectedCurrCode: selectedRate === null || selectedRate === void 0 ? void 0 : selectedRate.code,
                                        translationsData: translationsData,
                                        requestFormDetails: requestFormDetails,
                                        requestFormInfo: requestFormInfo
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerPageProduct_CustomSocialLinks, {
                                        dbName: dbName,
                                        domain: domain,
                                        productSlug: productSlug
                                    })
                                ]
                            })
                        ]
                    }),
                    showBuilderComponents(2)["".concat(showBuilderData)],
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerPageProduct_CustomDetailTabButtons, {
                        boxAboutDetailsClass: showBoxAboutDetails["".concat(showDetailsInFront)],
                        isSelectedDetailSectionClass: isSelectedDetailSectionClass(descriptions, details)["".concat(isSelectDetail)],
                        productDescOptionName: productDescOptionName,
                        Details_INTL: translationsData === null || translationsData === void 0 ? void 0 : translationsData.Details,
                        selectTab: selectTab,
                        showDescription: !!productDesc,
                        showDetailsInFront: showDetailsInFront
                    }),
                    isSelectedDetailSectionClass(descriptions, details)["".concat(isSelectDetail)].content,
                    showBuilderComponents(3)["".concat(showBuilderData)]
                ]
            })
        ]
    });
};
/* harmony default export */ var InnerPageProduct_CustomDownloadableProduct = (CustomDownloadableProduct);

// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./components/ForCWV/Products/BlockHeader/index.tsx
var BlockHeader = __webpack_require__(98503);
// EXTERNAL MODULE: ./components/ForCWV/Products/ProductCard.tsx
var ProductCard = __webpack_require__(84937);
;// CONCATENATED MODULE: ./components/ForCWV/InnerPageProduct/CustomRelatedBlock.tsx








var CustomRelatedBlock = function(param) {
    var title = param.title, products = param.products, dbName = param.dbName, translationsData = param.translationsData, backOrderValue = param.backOrderValue, selectedCurrItems = param.selectedCurrItems, selectedLocale = param.selectedLocale;
    var settings = {
        slidesToShow: 4,
        arrows: false,
        infinite: false,
        swipeToSlide: true,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 425,
                settings: {
                    slidesToShow: 2
                }
            }, 
        ]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (customInnerPage_module_default()).related_block,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockHeader/* default */.Z, {
                    title: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, settings), {
                    children: products.map(function(product) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard/* default */.Z, {
                            product: product,
                            dbName: dbName,
                            translationsData: translationsData,
                            backOrderValue: backOrderValue,
                            selectedCurrItems: selectedCurrItems,
                            selectedLocale: selectedLocale,
                            priority: false,
                            loading: "lazy"
                        }, product.id);
                    })
                }))
            ]
        })
    });
};
/* harmony default export */ var InnerPageProduct_CustomRelatedBlock = (CustomRelatedBlock);

// EXTERNAL MODULE: ./components/builder/BuilderDataRender.tsx + 31 modules
var BuilderDataRender = __webpack_require__(42289);
// EXTERNAL MODULE: ./atoms/forProduct/CustomSelect/customSelect.module.scss
var customSelect_module = __webpack_require__(99695);
var customSelect_module_default = /*#__PURE__*/__webpack_require__.n(customSelect_module);
;// CONCATENATED MODULE: ./hooks/useOutside.tsx

var useOutside = function(param) {
    var setOpen = param.setOpen;
    var optionRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var handleClickOutside = function handleClickOutside(event) {
            if (optionRef.current && !optionRef.current.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        optionRef
    ]);
    return {
        optionRef: optionRef
    };
};
/* harmony default export */ var hooks_useOutside = (useOutside);

;// CONCATENATED MODULE: ./atoms/forProduct/CustomSelect/index.tsx






var CustomSelect = function(param) {
    var selectArray = param.selectArray, setOptionQuantity = param.setOptionQuantity, optionQuantity = param.optionQuantity;
    var defaultValueExist = (selectArray === null || selectArray === void 0 ? void 0 : selectArray.find(function(item) {
        return !!item.is_default;
    })) || {
        name: "Select Option",
        id: 0,
        is_default: 1,
        bundleOptionId: 1,
        productQty: 1,
        optionDefaultQty: 1,
        price: 0
    };
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1 = (0,react.useState)(defaultValueExist), selectVal = ref1[0], setSelectVal = ref1[1];
    var optionRef = hooks_useOutside({
        setOpen: setOpen
    }).optionRef;
    var handleOptionClick = function(value) {
        setOpen(false);
        setSelectVal(value);
        var findOptQty = optionQuantity.find(function(param) {
            var bundleOptionId = param.bundleOptionId;
            return bundleOptionId === value.bundleOptionId;
        });
        if (findOptQty) {
            setOptionQuantity(function(prevState) {
                var spliceThisItem = prevState.filter(function(filteredElem) {
                    return filteredElem.bundleOptionId !== (findOptQty === null || findOptQty === void 0 ? void 0 : findOptQty.bundleOptionId);
                });
                return (0,_to_consumable_array/* default */.Z)(spliceThisItem).concat([
                    value
                ]);
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: optionRef,
        className: (customSelect_module_default()).main,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (customSelect_module_default()).select,
                onClick: function() {
                    return setOpen(function(prevState) {
                        return !prevState;
                    });
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: selectVal.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* DropDownArrow */.s0, {
                        className: "".concat(open ? (customSelect_module_default()).rotT_fms : "")
                    })
                ]
            }),
            open ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (customSelect_module_default()).optionBox,
                children: selectArray.map(function(option) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((customSelect_module_default()).select, " ").concat((customSelect_module_default()).eachOption),
                        onClick: function() {
                            return handleOptionClick(option);
                        },
                        children: option.name
                    }, option.id);
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {})
        ]
    });
};
/* harmony default export */ var forProduct_CustomSelect = (CustomSelect);

;// CONCATENATED MODULE: ./atoms/forProduct/CustomMultiSelect/index.tsx







var CustomMultiSelect = function(param) {
    var selectArray = param.selectArray, setOptionQuantity = param.setOptionQuantity, optionQuantity = param.optionQuantity;
    var defaultValueExist = (selectArray === null || selectArray === void 0 ? void 0 : selectArray.find(function(item) {
        return !!item.is_default;
    })) || {
        name: "Select Option",
        id: 0,
        is_default: 1,
        bundleOptionId: 1,
        productQty: 1,
        optionDefaultQty: 1,
        price: 0
    };
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1 = (0,react.useState)([
        defaultValueExist
    ]), selectVal = ref1[0], setSelectVal = ref1[1];
    var optionRef = hooks_useOutside({
        setOpen: setOpen
    }).optionRef;
    var handleOptionClick = function(value, state, setState) {
        var findThatItem = state.findIndex(function(item) {
            return item.id === value.id;
        });
        if (findThatItem === -1) {
            setState(function(prevState) {
                return (0,_to_consumable_array/* default */.Z)(prevState).concat([
                    value
                ]);
            });
        } else {
            setState(function(prevState) {
                return prevState.filter(function(_, index) {
                    return index !== findThatItem;
                });
            });
        }
    };
    var handleRemoveClick = function(e, value, setState) {
        e.stopPropagation();
        setState(function(prevState) {
            return prevState.filter(function(item) {
                return item.id !== value.id;
            });
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (customSelect_module_default()).main,
        ref: optionRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (customSelect_module_default()).select,
                onClick: function() {
                    return setOpen(function(prevState) {
                        return !prevState;
                    });
                },
                children: [
                    defaultValueExist.name === "Select Option" || selectVal.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Select Option"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (customSelect_module_default()).multiBoxMain,
                        children: selectVal.map(function(multiItem) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (customSelect_module_default()).multiItemBox,
                                onClick: function(e) {
                                    return e.stopPropagation();
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: multiItem.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        style: {
                                            marginLeft: "5px"
                                        },
                                        onClick: function(e) {
                                            handleRemoveClick(e, multiItem, setSelectVal);
                                            handleChangeOutsideForMulti({
                                                target: {
                                                    value: JSON.stringify(multiItem),
                                                    id: multiItem.id
                                                }
                                            }, optionQuantity, setOptionQuantity);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* CloseSvg */.sZ, {})
                                    })
                                ]
                            }, multiItem.id);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* DropDownArrow */.s0, {
                        className: "".concat(open ? (customSelect_module_default()).rotT_fms : "")
                    })
                ]
            }),
            open ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (customSelect_module_default()).optionBox,
                children: selectArray === null || selectArray === void 0 ? void 0 : selectArray.map(function(elem) {
                    var existThisValue = !!selectVal.find(function(selectedItem) {
                        return selectedItem.id === elem.id;
                    });
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((customSelect_module_default()).select, " ").concat((customSelect_module_default()).eachOption, " ").concat(existThisValue ? (customSelect_module_default()).grayBox : ""),
                        onClick: function() {
                            handleOptionClick(elem, selectVal, setSelectVal);
                            handleChangeOutsideForMulti({
                                target: {
                                    value: JSON.stringify(elem),
                                    id: elem.id
                                }
                            }, optionQuantity, setOptionQuantity);
                        },
                        children: elem.name
                    }, elem.id);
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {})
        ]
    });
};
/* harmony default export */ var forProduct_CustomMultiSelect = (CustomMultiSelect);

// EXTERNAL MODULE: ./atoms/forProduct/CustomRadio/customRadio.module.scss
var customRadio_module = __webpack_require__(9607);
var customRadio_module_default = /*#__PURE__*/__webpack_require__.n(customRadio_module);
;// CONCATENATED MODULE: ./atoms/forProduct/CustomRadio/index.tsx



var CustomRadio = function(param) {
    var selectArray = param.selectArray, setOptionQuantity = param.setOptionQuantity, optionQuantity = param.optionQuantity;
    var defaultValueExist = selectArray === null || selectArray === void 0 ? void 0 : selectArray.find(function(item) {
        return !!item.is_default;
    });
    var handleChange = function(e) {
        var value = JSON.parse(e.target.value);
        var findOptQty = optionQuantity.find(function(param) {
            var bundleOptionId = param.bundleOptionId;
            return bundleOptionId === value.bundleOptionId;
        });
        if (findOptQty) {
            setOptionQuantity(function(prevState) {
                var spliceThisItem = prevState.filter(function(filteredElem) {
                    return filteredElem.bundleOptionId !== (findOptQty === null || findOptQty === void 0 ? void 0 : findOptQty.bundleOptionId);
                });
                return (0,_to_consumable_array/* default */.Z)(spliceThisItem).concat([
                    value
                ]);
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (customRadio_module_default()).main,
        children: selectArray === null || selectArray === void 0 ? void 0 : selectArray.map(function(elem) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (customRadio_module_default()).optionMain,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        defaultChecked: defaultValueExist && elem.id === defaultValueExist.id,
                        type: "radio",
                        id: "".concat(elem.id),
                        name: "option",
                        value: JSON.stringify(elem),
                        onChange: handleChange
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: "".concat(elem.id),
                        children: elem.name
                    })
                ]
            }, elem.id);
        })
    });
};
/* harmony default export */ var forProduct_CustomRadio = (CustomRadio);

;// CONCATENATED MODULE: ./atoms/forProduct/CustomCheckbox/index.tsx





var CustomCheckbox = function(param) {
    var selectArray = param.selectArray, setOptionQuantity = param.setOptionQuantity, optionQuantity = param.optionQuantity;
    var defaultValueExist = selectArray === null || selectArray === void 0 ? void 0 : selectArray.find(function(item) {
        return !!item.is_default;
    });
    var ref = (0,react.useState)(defaultValueExist ? [
        defaultValueExist
    ] : []), optionArr = ref[0], setOptionArr = ref[1];
    var handleChangeInside = function(e) {
        var existThisVal = optionArr.findIndex(function(option) {
            return String(option === null || option === void 0 ? void 0 : option.id) === e.target.id;
        });
        var value = JSON.parse(e.target.value);
        if (existThisVal === -1) {
            setOptionArr(function(prevState) {
                return (0,_to_consumable_array/* default */.Z)(prevState).concat([
                    value
                ]);
            });
        } else {
            setOptionArr(function(prevState) {
                return prevState.filter(function(_, index) {
                    return existThisVal !== index;
                });
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (customRadio_module_default()).main,
        children: selectArray === null || selectArray === void 0 ? void 0 : selectArray.map(function(elem) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (customRadio_module_default()).optionMain,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "checkbox",
                        id: "".concat(elem.id),
                        name: "option",
                        value: JSON.stringify(elem),
                        onChange: function(event) {
                            handleChangeInside(event);
                            handleChangeOutsideForMulti(event, optionQuantity, setOptionQuantity);
                        },
                        defaultChecked: defaultValueExist && elem.id === defaultValueExist.id
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: "".concat(elem.id),
                        children: elem.name
                    })
                ]
            }, elem.id);
        })
    });
};
/* harmony default export */ var forProduct_CustomCheckbox = (CustomCheckbox);

;// CONCATENATED MODULE: ./components/ForCWV/InnerPageProduct/CustomBundle.tsx































var CustomBundle = function(param) {
    var dbName = param.dbName, productSlug = param.productSlug, domain = param.domain, selectedRate = param.selectedRate, product = param.product, translationsData = param.translationsData, selectedLocale = param.selectedLocale, schemaBrandName = param.schemaBrandName, showDetailsInFront = param.showDetailsInFront, showBuilderComponents = param.showBuilderComponents, showBuilderData = param.showBuilderData, requestFormInfo = param.requestFormInfo, requestFormDetails = param.requestFormDetails, sizeChart = param.sizeChart;
    var _Math;
    var ref, ref1;
    var ref2 = (0,react.useState)(product), clientSideProduct = ref2[0], setClientSideProduct = ref2[1];
    var tmp = product.flats, ref3 = (0,_sliced_to_array/* default */.Z)(tmp === void 0 ? [] : tmp, 1), tmp1 = ref3[0], ref4 = tmp1 === void 0 ? {} : tmp1, tmp2 = ref4.name, productName = tmp2 === void 0 ? "" : tmp2, tmp3 = ref4.description, productDesc = tmp3 === void 0 ? "" : tmp3, tmp4 = ref4.short_description, productShortDesc = tmp4 === void 0 ? "" : tmp4, tmp5 = ref4.price_html, productPriceHtml = tmp5 === void 0 ? null : tmp5, tmp6 = product.images, ref5 = (0,_sliced_to_array/* default */.Z)(tmp6 === void 0 ? [] : tmp6, 1), tmp7 = ref5[0], productImgPath = tmp7 === void 0 ? "" : tmp7, productId = product.id, tmp8 = product.sku, productSku = tmp8 === void 0 ? "" : tmp8, tmp9 = product.details, productDetails = tmp9 === void 0 ? [] : tmp9, tmp10 = product.sku_option, ref6 = tmp10 === void 0 ? {} : tmp10, tmp11 = ref6.name, productSkuOptionName = tmp11 === void 0 ? "SKU" : tmp11, tmp12 = product.short_description_option, ref7 = tmp12 === void 0 ? {} : tmp12, tmp13 = ref7.name, productShortDescOptionName = tmp13 === void 0 ? "" : tmp13, tmp14 = product.description_option, ref8 = tmp14 === void 0 ? {} : tmp14, tmp15 = ref8.name, productDescOptionName = tmp15 === void 0 ? "" : tmp15, bundle_options = product.bundle_options;
    var stateDefaultValue = bundle_options.map(function(param) {
        var option_product_info = param.option_product_info;
        return (option_product_info === null || option_product_info === void 0 ? void 0 : option_product_info.find(function(findItem) {
            return !!findItem.is_default;
        })) || {};
    });
    var ref9 = (0,react.useState)(1), productQuantity = ref9[0], setProductQuantity = ref9[1];
    var ref10 = (0,react.useState)(stateDefaultValue), optionQuantity = ref10[0], setOptionQuantity = ref10[1];
    var ref11 = (0,react.useState)([]), errorHandleIds = ref11[0], setErrorHandleIds = ref11[1];
    var ref12 = (0,react.useState)(!productDesc), isSelectDetail = ref12[0], setIsSelectDetail = ref12[1];
    var cartToken = (0,es/* useSelector */.v9)(function(state) {
        return state.cartToken;
    });
    var ref13 = (0,es/* useSelector */.v9)(function(state) {
        return state.customer;
    }), customerToken = ref13.token;
    var signed = (0,es/* useSelector */.v9)(function(state) {
        return state.customer.authenticated;
    });
    var wishlist = (0,es/* useSelector */.v9)(function(state) {
        return state.wishlist;
    });
    var openModalLayout = (0,es/* useSelector */.v9)(function(state) {
        return state.general.openModalLayout;
    });
    var isProductInWishList = wishlist === null || wishlist === void 0 ? void 0 : wishlist.find(function(item) {
        return item.id === productId;
    });
    var ref14 = (0,react.useState)(/*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* HeartSvg */.xO, {})), wishIcon = ref14[0], setWishIcon = ref14[1];
    var maxQty = (_Math = Math).min.apply(_Math, (0,_to_consumable_array/* default */.Z)(optionQuantity.map(function(qtyConcat) {
        return Math.floor(qtyConcat.productQty / qtyConcat.optionDefaultQty);
    })));
    (0,react.useEffect)(function() {
        setWishIcon(!!isProductInWishList ? /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* HeartActive */.wL, {
            className: (customInnerPage_module_default())["inner-wishlist"]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* HeartSvg */.xO, {}));
    }, [
        isProductInWishList
    ]);
    var dispatch = (0,es/* useDispatch */.I0)();
    var toast = (0,useToast/* useToast */.p)();
    var ref15 = (0,next_router.useRouter)(), asPath = ref15.asPath, routerPush = ref15.push;
    var bundleOptionIds = bundle_options.map(function(opt) {
        return opt.id;
    });
    var isAnyElemNotSelected = bundleOptionIds.filter(function(elem) {
        return !Boolean(optionQuantity.find(function(param) {
            var bundleOptionId = param.bundleOptionId;
            return bundleOptionId === elem;
        }));
    });
    (0,react.useEffect)(function() {
        setOptionQuantity(stateDefaultValue);
    }, [
        asPath
    ]);
    var addToast = function(error) {
        if (error) {
            toast.open(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "d-flex chek-fms",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* FailSvg */.as, {}),
                    translationsData.ProductNotAvailable
                ]
            }));
        } else if (!isAnyElemNotSelected.length) {
            toast.open(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "d-flex chek-fms",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* CheckToastSvg */.xQ, {}),
                    translationsData.ToastAddToCart
                ]
            }));
        }
    };
    var schema = schemaProduct(asPath, productName, productDesc, productImgPath, productSku, productId, dbName, domain, schemaBrandName);
    var handleAmdPrice = function(param, price) {
        var currCode = param.code;
        if (price) {
            var currentCurrCodeIsAmdOrRub = currCode.toLowerCase() === "amd" || currCode.toLowerCase() === "rub";
            if (!currentCurrCodeIsAmdOrRub) {
                return Number(price).toFixed(2);
            }
            return +price;
        }
        return null;
    };
    var handlePriceFormat = function(price) {
        if (price) {
            return String(price).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
        return null;
    };
    (0,react.useEffect)(function() {
        var totalPrice = optionQuantity.reduce(function(total, param) {
            var optionDefaultQty = param.optionDefaultQty, price = param.price;
            return total + optionDefaultQty * price;
        }, 0);
        setClientSideProduct(function(prevState) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                flats: [
                    {
                        min_price: totalPrice,
                        price: totalPrice
                    }
                ]
            });
        });
    }, [
        optionQuantity
    ]);
    useFetchCartToken(cartToken);
    (0,react.useEffect)(function() {
        setProductQuantity(function(prevState) {
            if (maxQty < prevState) return maxQty;
            return prevState;
        });
    }, [
        maxQty
    ]);
    var selectTab = function(e) {
        setIsSelectDetail(e.target.id === "detail");
    };
    var handleWishIconClick = function(e) {
        e.preventDefault();
        if (!signed) {
            toast.open(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "d-flex faild-toast-fms",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* FailSvg */.as, {}),
                    translationsData.ToastSignIn
                ]
            }));
        } else {
            !!isProductInWishList ? dispatch((0,wishlistActions/* wishlistRemoveItem */.uv)(product.id)) : dispatch((0,wishlistActions/* wishlistAddItem */.c8)(product, selectedLocale));
            var toastChildren = {
                "true": {
                    svg: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* FailSvg */.as, {}),
                    title: translationsData === null || translationsData === void 0 ? void 0 : translationsData.ToastWishListRemove
                },
                "false": {
                    svg: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* CheckToastSvg */.xQ, {}),
                    title: translationsData === null || translationsData === void 0 ? void 0 : translationsData.ToastWishList
                }
            };
            toast.open(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "d-flex faild-toast-fms",
                children: [
                    toastChildren["".concat(!!isProductInWishList)].svg,
                    toastChildren["".concat(!!isProductInWishList)].title
                ]
            }));
        }
    };
    var descriptions = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "product-inner-long-description",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                paddingLeft: "30px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: productDesc
                }
            })
        })
    });
    var details = /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerPageProduct_CustomDetails, {
        details: productDetails,
        isSelectDetail: isSelectDetail,
        showDetailsInFront: showDetailsInFront,
        translationsData: translationsData,
        dbName: dbName,
        domain: domain
    });
    var handleAddCartClickLocal = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var quantity, qtyOptionSend;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        quantity = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : 1;
                        setErrorHandleIds(function() {
                            return isAnyElemNotSelected;
                        });
                        qtyOptionSend = function(forQty) {
                            return optionQuantity.reduce(function(prevValue, param) {
                                var id = param.id, bundleOptionId = param.bundleOptionId, optionDefaultQty = param.optionDefaultQty;
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevValue), (0,_define_property/* default */.Z)({}, bundleOptionId, forQty ? optionDefaultQty : id.length > 0 ? id : [
                                    id
                                ]));
                            }, {});
                        };
                        if (!!isAnyElemNotSelected.length) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0,helpers/* handleAddCard */.x)({
                                openUpCrossProd: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        return [
                                            2,
                                            false
                                        ];
                                    });
                                }),
                                dispatch: dispatch,
                                data: {
                                    product: product,
                                    quantity: quantity,
                                    cartToken: cartToken,
                                    customer: {
                                        token: customerToken
                                    },
                                    selectedLocale: selectedLocale,
                                    selectedCurrCode: selectedRate.code,
                                    optionsObject: null,
                                    addToast: addToast,
                                    links: [],
                                    bundle_options: qtyOptionSend(false),
                                    bundle_option_qty: qtyOptionSend(true)
                                },
                                routerPush: routerPush,
                                isProductInStock: true
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleAddCartClickLocal() {
            return _ref.apply(this, arguments);
        };
    }();
    var ProductPriceToggle = function() {
        var specialPrice = handlePriceFormat(handleAmdPrice(selectedRate, clientSideProduct.flats[0].special_price));
        var price = handlePriceFormat(handleAmdPrice(selectedRate, clientSideProduct.flats[0].price));
        var pricePositionHandle = function(whichPrice) {
            if ((selectedRate === null || selectedRate === void 0 ? void 0 : selectedRate.code) === "AMD") {
                return whichPrice + " " + (selectedRate === null || selectedRate === void 0 ? void 0 : selectedRate.symbol);
            }
            return (selectedRate === null || selectedRate === void 0 ? void 0 : selectedRate.symbol) + " " + whichPrice;
        };
        var standardPriceJSX = function(whichPrice) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (customInnerPage_module_default()).price_value,
                children: pricePositionHandle(whichPrice)
            });
        };
        var PriceLayout = function() {
            if (specialPrice) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: [
                        {
                            clsKey: "new",
                            price: specialPrice
                        },
                        {
                            clsKey: "old",
                            price: price
                        }
                    ].map(function(elem) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (customInnerPage_module_default())["product-card__".concat(elem.clsKey, "-price")],
                            children: standardPriceJSX(elem.price)
                        }, elem.clsKey);
                    })
                });
            }
            return standardPriceJSX(price);
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (customInnerPage_module_default()).product__price,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceLayout, {})
        });
    };
    var ShowSizeChart = function() {
        if (sizeChart) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (customInnerPage_module_default())["product-inner-chart-title"],
                        style: {
                            margin: "12px 0",
                            cursor: "pointer"
                        },
                        onClick: function() {
                            return dispatch((0,general/* openModalLayoutAction */.oJ)(true));
                        },
                        children: translationsData === null || translationsData === void 0 ? void 0 : translationsData.ViewSizeChart
                    }),
                    openModalLayout ? /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_ModalLayout, {
                        close: function() {
                            return dispatch((0,general/* openModalLayoutAction */.oJ)(false));
                        },
                        title: sizeChart === null || sizeChart === void 0 ? void 0 : sizeChart.template_name,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerPageProduct_SizeChartContent, {
                            sizeChart: sizeChart,
                            dbName: dbName,
                            domain: domain
                        })
                    }) : null
                ]
            });
        }
        return null;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: schema.name,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(schema)
                },
                defer: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (customInnerPage_module_default()).product__content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomProductGallery/* default */.Z, {
                                images: product.images,
                                dbName: dbName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (customInnerPage_module_default()).product__info,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        style: {
                                            textAlign: "left"
                                        },
                                        className: (customInnerPage_module_default()).product__name,
                                        children: productName
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: (customInnerPage_module_default()).product__sku,
                                        children: [
                                            productSkuOptionName,
                                            ": ",
                                            productSku
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPriceToggle, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowSizeChart, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: productPriceHtml ? (ref = product === null || product === void 0 ? void 0 : product.flats[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.price_html) === null || ref1 === void 0 ? void 0 : ref1.map(function(e, i) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (customInnerPage_module_default()).product_price_html,
                                                children: e
                                            }, i);
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {})
                                    }),
                                    (productShortDesc === null || productShortDesc === void 0 ? void 0 : productShortDesc.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (customInnerPage_module_default())["product-inner-description-title"],
                                        children: productShortDescOptionName
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        dangerouslySetInnerHTML: {
                                            __html: productShortDesc
                                        }
                                    }),
                                    bundle_options.map(function(param) {
                                        var option_product_info = param.option_product_info, type = param.type, label = param.label, id = param.id, is_required = param.is_required;
                                        var bundleElemProps = {
                                            selectArray: option_product_info,
                                            setOptionQuantity: setOptionQuantity,
                                            optionQuantity: optionQuantity,
                                            bundleId: id
                                        };
                                        var bundleComponents = {
                                            select: /*#__PURE__*/ (0,jsx_runtime.jsx)(forProduct_CustomSelect, (0,_object_spread/* default */.Z)({}, bundleElemProps)),
                                            radio: /*#__PURE__*/ (0,jsx_runtime.jsx)(forProduct_CustomRadio, (0,_object_spread/* default */.Z)({}, bundleElemProps)),
                                            checkbox: /*#__PURE__*/ (0,jsx_runtime.jsx)(forProduct_CustomCheckbox, (0,_object_spread/* default */.Z)({}, bundleElemProps)),
                                            multiselect: /*#__PURE__*/ (0,jsx_runtime.jsx)(forProduct_CustomMultiSelect, (0,_object_spread/* default */.Z)({}, bundleElemProps))
                                        };
                                        var filterOptionArr = optionQuantity.find(function(findItem) {
                                            return findItem.bundleOptionId === id;
                                        });
                                        var ref = filterOptionArr || {
                                            productQty: 1,
                                            optionDefaultQty: 1,
                                            id: null
                                        }, _productQty = ref.productQty, productQty = _productQty === void 0 ? 1 : _productQty, _optionDefaultQty = ref.optionDefaultQty, optionDefaultQty = _optionDefaultQty === void 0 ? 1 : _optionDefaultQty, tmp = ref.id, findId = tmp === void 0 ? null : tmp;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (customInnerPage_module_default()).options_main,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                                    children: [
                                                        label,
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: is_required ? "*" : ""
                                                        })
                                                    ]
                                                }),
                                                is_required && errorHandleIds.some(function(elemId) {
                                                    return elemId === id;
                                                }) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (customInnerPage_module_default())["err-block"],
                                                    children: translationsData.RequiredField
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {}),
                                                bundleComponents[type],
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (customInnerPage_module_default()).product__sidebar,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                                                        className: (customInnerPage_module_default()).product__options,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "form-group ".concat((customInnerPage_module_default()).product__option),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (customInnerPage_module_default()).product__actions,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "".concat((customInnerPage_module_default())["product__actions-item"], " ").concat((customInnerPage_module_default())["product-inner-quantity"]),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputNumber/* default */.Z, {
                                                                        id: "".concat(label).concat(id, "product-quantity"),
                                                                        "aria-label": "Quantity",
                                                                        className: (customInnerPage_module_default()).product__quantity,
                                                                        size: "lg",
                                                                        min: 1,
                                                                        max: productQty,
                                                                        value: optionDefaultQty || 1,
                                                                        onChange: function(quantity) {
                                                                            setOptionQuantity(function(prevState) {
                                                                                return prevState.map(function(elem) {
                                                                                    if (String(elem.id) === String(findId)) {
                                                                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, elem), {
                                                                                            optionDefaultQty: quantity
                                                                                        });
                                                                                    }
                                                                                    return elem;
                                                                                });
                                                                            });
                                                                        }
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    })
                                                })
                                            ]
                                        }, id);
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: (customInnerPage_module_default()).product__meta,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: (customInnerPage_module_default())["product__meta-availability"],
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: dangerOrSuccessStyleSimple["".concat(!isAnyElemNotSelected.length)].className,
                                                    style: {
                                                        fontSize: "18px"
                                                    },
                                                    children: translationsData === null || translationsData === void 0 ? void 0 : translationsData[dangerOrSuccessStyleSimple["".concat(!isAnyElemNotSelected.length)].ItlKey]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((customInnerPage_module_default())["product__actions-item"], " ").concat((customInnerPage_module_default())["product-inner-quantity"]),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputNumber/* default */.Z, {
                                                    id: "product-quantity",
                                                    "aria-label": "Quantity",
                                                    className: (customInnerPage_module_default()).product__quantity,
                                                    size: "lg",
                                                    min: 1,
                                                    max: maxQty,
                                                    value: productQuantity,
                                                    onChange: function(quantity) {
                                                        if (quantity > maxQty) {
                                                            setProductQuantity(maxQty);
                                                        } else {
                                                            setProductQuantity(quantity);
                                                        }
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerPageProduct_CustomSideBar, {
                                        ProductAddToCart_INTL: translationsData === null || translationsData === void 0 ? void 0 : translationsData.AddToCartButtonTitle,
                                        actionClassName: addCartDivStyleToggleSimple["".concat(!isAnyElemNotSelected.length)],
                                        handleCardClick: handleAddCartClickLocal,
                                        isButtonDisabled: false,
                                        wishListButtonClick: handleWishIconClick,
                                        wishIconClicked: wishIcon,
                                        minimalQty: 1,
                                        maximalQty: maxQty,
                                        inpValQuantity: productQuantity,
                                        setQuantity: setProductQuantity,
                                        requestFormInfo: requestFormInfo,
                                        requestFormDetails: requestFormDetails
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerPageProduct_CustomSocialLinks, {
                                        dbName: dbName,
                                        domain: domain,
                                        productSlug: productSlug
                                    })
                                ]
                            })
                        ]
                    }),
                    showBuilderComponents(2)["".concat(showBuilderData)],
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerPageProduct_CustomDetailTabButtons, {
                        boxAboutDetailsClass: showBoxAboutDetails["".concat(showDetailsInFront)],
                        isSelectedDetailSectionClass: isSelectedDetailSectionClass(descriptions, details)["".concat(isSelectDetail)],
                        productDescOptionName: productDescOptionName,
                        Details_INTL: translationsData === null || translationsData === void 0 ? void 0 : translationsData.Details,
                        selectTab: selectTab,
                        showDescription: !!productDesc,
                        showDetailsInFront: showDetailsInFront
                    }),
                    isSelectedDetailSectionClass(descriptions, details)["".concat(isSelectDetail)].content
                ]
            })
        ]
    });
};
/* harmony default export */ var InnerPageProduct_CustomBundle = (CustomBundle);

// EXTERNAL MODULE: ./components/builder/Button/FormModal/index.tsx
var FormModal = __webpack_require__(44487);
// EXTERNAL MODULE: ./components/shared/PageHeader.tsx
var PageHeader = __webpack_require__(64465);
;// CONCATENATED MODULE: ./components/ForCWV/InnerPageProduct/CustomShopProduct.tsx












var CustomShopProduct = function(param) {
    var dbName = param.dbName, domain = param.domain, productSlug = param.productSlug, selectedRate = param.selectedRate, product = param.product, backOrderValue = param.backOrderValue, customerGroupPrices = param.customerGroupPrices, translationsData = param.translationsData, selectedLocale = param.selectedLocale, schemaBrandName = param.schemaBrandName, showDetailsInFront = param.showDetailsInFront, breadcrumb = param.breadcrumb, relatedProducts = param.relatedProducts, selectedCurrItems = param.selectedCurrItems, builderProps = param.builderProps, showBuilderData = param.showBuilderData, requestFormInfo = param.requestFormInfo, recaptchaActive = param.recaptchaActive, requestFormDetails = param.requestFormDetails, sizeChart = param.sizeChart;
    var ref, ref1, ref2, ref3;
    var popupOpen = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return (ref = state.formBuilder) === null || ref === void 0 ? void 0 : ref.popup_open;
    });
    var showBuilderComponents = function(id) {
        var ref, ref1, ref2;
        return {
            "true": /*#__PURE__*/ (0,jsx_runtime.jsx)(BuilderDataRender/* default */.Z, (0,_object_spread/* default */.Z)({
                tab: id,
                productInfo: {
                    sku: product === null || product === void 0 ? void 0 : product.sku,
                    image: product === null || product === void 0 ? void 0 : (ref = product.images) === null || ref === void 0 ? void 0 : ref[0],
                    name: product === null || product === void 0 ? void 0 : (ref1 = product.flats) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.name
                }
            }, builderProps)),
            "false": null
        };
    };
    var productProps = {
        backOrderValue: backOrderValue,
        dbName: dbName,
        domain: domain,
        translationsData: translationsData,
        productSlug: productSlug,
        selectedRate: selectedRate,
        product: product,
        selectedLocale: selectedLocale,
        schemaBrandName: schemaBrandName,
        showDetailsInFront: showDetailsInFront,
        showBuilderComponents: showBuilderComponents,
        showBuilderData: showBuilderData,
        requestFormInfo: requestFormInfo,
        requestFormDetails: requestFormDetails,
        sizeChart: sizeChart
    };
    var productShowHandle = {
        simple: /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerPageProduct_CustomProduct, (0,_object_spread/* default */.Z)({
            customerGroupPrices: customerGroupPrices
        }, productProps)),
        configurable: /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerPageProduct_CustomConfig, (0,_object_spread/* default */.Z)({}, productProps)),
        virtual: /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerPageProduct_CustomProduct, (0,_object_spread/* default */.Z)({
            customerGroupPrices: customerGroupPrices
        }, productProps)),
        downloadable: /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerPageProduct_CustomDownloadableProduct, (0,_object_spread/* default */.Z)({}, productProps)),
        bundle: /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerPageProduct_CustomBundle, (0,_object_spread/* default */.Z)({
            customerGroupPrices: customerGroupPrices
        }, productProps))
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader/* default */.Z, {
                dbName: dbName,
                breadcrumb: breadcrumb
            }),
            showBuilderComponents(1)["".concat(showBuilderData)],
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    margin: "50px auto"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: productShowHandle["".concat(product.type)]
                })
            }),
            relatedProducts.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerPageProduct_CustomRelatedBlock, {
                title: translationsData === null || translationsData === void 0 ? void 0 : translationsData.RelatedProducts,
                products: relatedProducts,
                dbName: dbName,
                translationsData: translationsData,
                backOrderValue: backOrderValue,
                selectedCurrItems: selectedCurrItems,
                selectedLocale: selectedLocale
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {}),
            showBuilderComponents(3)["".concat(showBuilderData)],
            requestFormInfo && (popupOpen === null || popupOpen === void 0 ? void 0 : popupOpen.open) && (popupOpen === null || popupOpen === void 0 ? void 0 : popupOpen.id) === (requestFormInfo === null || requestFormInfo === void 0 ? void 0 : (ref = requestFormInfo.data) === null || ref === void 0 ? void 0 : ref.id) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FormModal/* default */.Z, {
                productInfo: {
                    sku: product === null || product === void 0 ? void 0 : product.sku,
                    image: product === null || product === void 0 ? void 0 : (ref1 = product.images) === null || ref1 === void 0 ? void 0 : ref1[0],
                    name: product === null || product === void 0 ? void 0 : (ref2 = product.flats) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.name
                },
                title: requestFormDetails === null || requestFormDetails === void 0 ? void 0 : requestFormDetails.requestFormTitle,
                form: {
                    formComponentInfo: requestFormInfo,
                    customClassNames: ""
                },
                recaptchaActive: recaptchaActive
            }) : null
        ]
    });
};
/* harmony default export */ var InnerPageProduct_CustomShopProduct = (CustomShopProduct);

// EXTERNAL MODULE: ./components/shared/ReCaptchaWrapper.tsx
var ReCaptchaWrapper = __webpack_require__(2598);
;// CONCATENATED MODULE: ./pages/[productSlug].tsx











var ProductInnerPage = function(pageProps) {
    var productSlug = pageProps.productSlug, serverSideProduct = pageProps.serverSideProduct, relatedProducts = pageProps.relatedProducts, customerGroupPrices = pageProps.customerGroupPrices, breadcrumb = pageProps.breadcrumb, schemaBrandName = pageProps.schemaBrandName, showDetailsInFront = pageProps.showDetailsInFront, dbName = pageProps.dbName, translationsData = pageProps.translationsData, backOrderValue = pageProps.backOrderValue, domain = pageProps.domain, selectedRate = pageProps.selectedRate, locale = pageProps.selectedLocale, _currencies = pageProps.currencies, currencies = _currencies === void 0 ? [] : _currencies, getBuilderData = pageProps.getBuilderData, showBuilderData = pageProps.showBuilderData, isMobile = pageProps.isMobile, recaptchaActive = pageProps.recaptchaActive, recaptchaKey = pageProps.recaptchaKey, siteName = pageProps.siteName, requestFormInfo = pageProps.requestFormInfo, requestFormDetails = pageProps.requestFormDetails, defaultLangCode = pageProps.defaultLangCode, locales = pageProps.locales, sizeChart = pageProps.sizeChart;
    var router = (0,next_router.useRouter)();
    var _currencies1 = (0,_sliced_to_array/* default */.Z)(currencies, 1), tmp = _currencies1[0], ref = tmp === void 0 ? {} : tmp, tmp1 = ref.code, selectedCurrCode = tmp1 === void 0 ? "" : tmp1, tmp2 = ref.symbol, selectedCurrSymbol = tmp2 === void 0 ? "" : tmp2, tmp3 = ref.exchange_rate, ref1 = tmp3 === void 0 ? {} : tmp3, tmp4 = ref1.rate, selectedCurrRate = tmp4 === void 0 ? "1" : tmp4;
    var selectedCurrItems = {
        selectedCurrCode: selectedCurrCode,
        selectedCurrRate: selectedCurrRate,
        selectedCurrSymbol: selectedCurrSymbol
    };
    var builderProps = {
        getBuilderData: getBuilderData,
        domain: domain,
        dbName: dbName,
        translationsData: translationsData,
        selectedLocale: locale,
        currencies: currencies,
        backOrderValue: backOrderValue,
        selectedCurrItems: selectedCurrItems,
        isMobile: isMobile,
        recaptchaActive: recaptchaActive
    };
    var ref2 = serverSideProduct || {}, _flats = ref2.flats, flats = _flats === void 0 ? [] : _flats, _yoast_products = ref2.yoast_products, yoast_products = _yoast_products === void 0 ? [] : _yoast_products;
    var _flats1 = (0,_sliced_to_array/* default */.Z)(flats, 1), tmp5 = _flats1[0], ref3 = tmp5 === void 0 ? {} : tmp5, tmp6 = ref3.meta_title, m_title = tmp6 === void 0 ? flats[0].name : tmp6, tmp7 = ref3.meta_description, m_desc = tmp7 === void 0 ? flats[0].short_description : tmp7, tmp8 = ref3.meta_keywords, m_keyword = tmp8 === void 0 ? "" : tmp8, tmp9 = ref3.url_key, m_url = tmp9 === void 0 ? "" : tmp9, tmp10 = ref3.meta_image, m_img = tmp10 === void 0 ? "" : tmp10;
    var _yoast_products1 = (0,_sliced_to_array/* default */.Z)(yoast_products, 1), tmp11 = _yoast_products1[0], ref4 = tmp11 === void 0 ? {} : tmp11, tmp12 = ref4.yoast_facebook_title, FB_title = tmp12 === void 0 ? m_title : tmp12, tmp13 = ref4.yoast_facebook_description, FB_desc = tmp13 === void 0 ? m_desc : tmp13, tmp14 = ref4.yoast_twitter_title, TW_title = tmp14 === void 0 ? m_keyword : tmp14, tmp15 = ref4.yoast_twitter_description, TW_desc = tmp15 === void 0 ? m_desc : tmp15, tmp16 = ref4.yoast_focus_keyword, y_keyword = tmp16 === void 0 ? m_keyword : tmp16;
    var canonicalUrl = "".concat(dbName, "/").concat(router.locale !== "catchAll" && router.locale !== defaultLangCode ? locale + "/" : "").concat(m_url);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReCaptchaWrapper/* default */.Z, {
        recaptchaActive: recaptchaActive,
        recaptchaKey: recaptchaKey,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLayout/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pageProps), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                                children: m_title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "title",
                                content: m_title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "description",
                                content: m_desc
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "keywords",
                                content: m_keyword
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "generator",
                                content: "Zegashop.com"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "robots",
                                content: "index, follow"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:title",
                                content: TW_title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:description",
                                content: TW_desc
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:image",
                                content: (0,helper/* domainUrl */.HJ)("".concat(dbName).concat(m_img))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:title",
                                content: FB_title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:description",
                                content: FB_desc
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:keywords",
                                content: y_keyword
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:image",
                                content: (0,helper/* domainUrl */.HJ)("".concat(dbName).concat(m_img))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:url",
                                content: (0,helper/* domainUrl */.HJ)(canonicalUrl)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:locale",
                                content: locale
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:site_name",
                                content: siteName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                rel: "canonical",
                                href: (0,helper/* domainUrl */.HJ)(canonicalUrl)
                            }),
                            (locales === null || locales === void 0 ? void 0 : locales.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                        rel: "alternate",
                                        href: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/").concat(m_url)),
                                        hrefLang: "x-default"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                        rel: "alternate",
                                        href: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/").concat(m_url)),
                                        hrefLang: defaultLangCode
                                    }),
                                    locales.map(function(intl) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                            rel: "alternate",
                                            href: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/").concat(intl.code, "/").concat(m_url)),
                                            hrefLang: intl.code
                                        });
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerPageProduct_CustomShopProduct, {
                        translationsData: translationsData,
                        breadcrumb: breadcrumb,
                        backOrderValue: backOrderValue,
                        dbName: dbName,
                        domain: domain,
                        productSlug: productSlug,
                        selectedRate: selectedRate,
                        selectedLocale: locale,
                        showDetailsInFront: showDetailsInFront,
                        product: serverSideProduct,
                        customerGroupPrices: customerGroupPrices,
                        schemaBrandName: schemaBrandName,
                        relatedProducts: relatedProducts,
                        selectedCurrItems: selectedCurrItems,
                        builderProps: builderProps,
                        showBuilderData: showBuilderData,
                        requestFormInfo: requestFormInfo,
                        recaptchaActive: recaptchaActive,
                        requestFormDetails: requestFormDetails,
                        sizeChart: sizeChart
                    })
                ]
            })
        }))
    });
};
var __N_SSP = true;
/* harmony default export */ var _productSlug_ = (ProductInnerPage);


/***/ }),

/***/ 9607:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"customRadio_main__W6XJy","optionMain":"customRadio_optionMain__f6v43"};

/***/ }),

/***/ 99695:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"multiItemBox":"customSelect_multiItemBox__yrXHd","multiBoxMain":"customSelect_multiBoxMain__cZpZX","grayBox":"customSelect_grayBox__sAFe8","main":"customSelect_main__wjcHq","select":"customSelect_select__coL3R","eachOption":"customSelect_eachOption__Be2kD","optionBox":"customSelect_optionBox__jhwuR","rotT_fms":"customSelect_rotT_fms__TZuSP"};

/***/ }),

/***/ 84632:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"block-header":"blockHeader_block-header__E_75W","block-header__title__custom":"blockHeader_block-header__title__custom__jv3eD","title-line-fms":"blockHeader_title-line-fms__y1iU4","title-name-fms":"blockHeader_title-name-fms__j9Nkd"};

/***/ }),

/***/ 30420:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"product--layout--columnar":"product_product--layout--columnar__NiSjf","product__content":"product_product__content__udV3j","product__gallery":"product_product__gallery__CVK0d","product__info":"product_product__info__A2gih","product__sidebar":"product_product__sidebar__UIWxu","product__footer":"product_product__footer__O_lf8","product__wishlist-compare":"product_product__wishlist-compare__rTpMp","product__name":"product_product__name__ZZE__","product__description":"product_product__description__c4cMk","product__features":"product_product__features__htBYF","product__meta":"product_product__meta__fRugS","product__meta-availability":"product_product__meta-availability__Szl8P","product__share-links":"product_product__share-links__5JxEN","product__prices":"product_product__prices___bME7","product__new-price":"product_product__new-price__fFvCI","product__quantity":"product_product__quantity__8n_CV","product__actions":"product_product__actions__jZdoG","product__actions-item--addToCart":"product_product__actions-item--addToCart__Lixrk","btn":"product_btn__2zTGI","product__actions-item--wishlist":"product_product__actions-item--wishlist__plklZ","product__actions-item--compare":"product_product__actions-item--compare__YHDI7","product__availability":"product_product__availability__2eRhE","product__option":"product_product__option__8m9lj","product__actions-item":"product_product__actions-item__PQUVc","configurable-attributes":"product_configurable-attributes__s5cJn","wr_dropDown_name":"product_wr_dropDown_name__0L9CI","dropdown_open_btn":"product_dropdown_open_btn__EYt8u","open":"product_open__Z_DqI","wr_img_dropDown_name":"product_wr_img_dropDown_name__sb8Rh","attr_fms":"product_attr_fms__Hs6mA","other-list-main-fms":"product_other-list-main-fms__6eCpB","label-attr__code":"product_label-attr__code__PAQ_f","selected_configue":"product_selected_configue__VGJjd","option_dropdown_btn":"product_option_dropdown_btn__RyddV","drop_down_arrow":"product_drop_down_arrow__mzIHC","drop_down_opened":"product_drop_down_opened__GiQbo","option_dropdown":"product_option_dropdown__wPICG","option_dropdown_value":"product_option_dropdown_value__a0fWJ","socialLinksBox":"product_socialLinksBox__ggwFD","active-title":"product_active-title__S14Hh","desc-heade-title":"product_desc-heade-title__Aa3Ne","other-radio__input":"product_other-radio__input__hAZGe","attr_space":"product_attr_space__8c5sp","attr_label_size":"product_attr_label_size__Lh2_g","filter-color__item":"product_filter-color__item___VJoz","d-block":"product_d-block__dsLYN","btn-wrapper":"product_btn-wrapper__eKrRF","product__rating":"product_product__rating__paqGx","product__rating-stars":"product_product__rating-stars__KMgNh","product__rating-legend":"product_product__rating-legend__8upbu","text-success":"product_text-success__vimzO","text-danger":"product_text-danger__U7duD","product_price_html":"product_product_price_html__qT_sO","product__old-price":"product_product__old-price__8j0DP","product__option-label":"product_product__option-label__tEVha","product__tags":"product_product__tags__seocH","product--layout--sidebar":"product_product--layout--sidebar__SsFwX","product--layout--quickview":"product_product--layout--quickview__P_Sfi","product_attributes":"product_product_attributes__67_DA","attr_color_fms":"product_attr_color_fms__gAq__","color-attr_fm":"product_color-attr_fm__up0jk","other-attr_fm":"product_other-attr_fm____fb0","product--layout--standard":"product_product--layout--standard__Y1Jdg","input-check-color__body":"product_input-check-color__body__PtAyR","other-list__item":"product_other-list__item__C5P4S","other-list__title":"product_other-list__title__5LPct","other-list__input":"product_other-list__input__ZTvFk","product-inner-quantity":"product_product-inner-quantity__rFLAA","product-inner-long-description":"product_product-inner-long-description__etAmV","d-none":"product_d-none__U99Rw","d-flex":"product_d-flex__ozpFT","input-number__input":"product_input-number__input__j0nvY","inner-addToCart":"product_inner-addToCart__OrYbT","quantity_table_title":"product_quantity_table_title__1AC1I","quantity_table_main":"product_quantity_table_main__q9tJb","quantity_table_row":"product_quantity_table_row___cuq5","quantity_table_item":"product_quantity_table_item__C5HiY","quantity_item_span":"product_quantity_item_span__RVbxd","price_item_span":"product_price_item_span__dwC_q","cart-quantity-responsive":"product_cart-quantity-responsive__FVN4t","button_disabled":"product_button_disabled__CtvY5","short-description":"product_short-description__d_grQ","short_description_block":"product_short_description_block__Ek6i9","rounded-pills":"product_rounded-pills__PT3gW","data-title-mob":"product_data-title-mob__scXsZ","product-inner-description-content":"product_product-inner-description-content__2kGF9","product-inner-description-title":"product_product-inner-description-title__In70t","product-inner-long-description-click":"product_product-inner-long-description-click__UycrN","liked-button-wrapper":"product_liked-button-wrapper__SMJt2","btn-light":"product_btn-light__FzzV6","btn-svg-icon--fake-svg":"product_btn-svg-icon--fake-svg__XK_Gw","tab_buttons":"product_tab_buttons__Vjvxn","tab":"product_tab__ZCT4p","tab_description":"product_tab_description__cYNDS","tab_description-active":"product_tab_description-active__9oAwA","tab_detail-active":"product_tab_detail-active__vPxic","only_one":"product_only_one__W_YvN","details_block":"product_details_block__ZGhzn","detail_row":"product_detail_row__WcPBn","detail_key":"product_detail_key__pzI4W","detail_value":"product_detail_value__AMk1B","detail_value_open":"product_detail_value_open__zxif8","detail_content":"product_detail_content__tL61K","icon_for_open":"product_icon_for_open__TzCj9","read_more":"product_read_more__BmtRz","active":"product_active__m6Wwe","mobile-buttons-config":"product_mobile-buttons-config__CzM6v","product-card__prices":"product_product-card__prices__q_2Qk","product-card__old-price":"product_product-card__old-price__wRjyg"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3061,7838,1818,3997,4531,2830,9774,2888,179], function() { return __webpack_exec__(37973); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);